// How to export the script, you can read the readme.md file (src/views/catalog/detail/description/exports/README.md)

// Section handlers

export function descriptionjs(options) {
  const scriptSectionType = {
    MARQUEE_TINO: 'section-marquee-tino',
    MARKQUEUE_ROWS: 'section-markqueue-rows',
    FB_POST_03: 'section-fb-post-03',
    CARD_VIDEO_SLIDER: 'section-card-video-slider',
    BANNER_SLIDER: 'section-banner-slider',
    CARD_ACCORDIONS: 'section-card-accordions',
    CARD_COMPARE_TWO_IMAGE: 'section-compare-two-img',
    CARD_COMPARE_YURI: 'section-card-compare-yuri',
    CARD_SLIDER_YURI: 'section-card-slider-yuri',
    REVIEW_SLIDER_YURI: 'section-review-slider-yuri',
    CARD_HAVE_VIEW_MORE: 'section-card-have-view-more',
    COLLAPSIBLE_PRODUCT_GRID: 'section-collapsible-product-grid',
    FAQ_GRID: 'section-faq-grid',
    FAQ_GRID_02: 'section-faq-grid-02',
    FAQ_GRID_03: 'section-faq-grid-03',
    FAQ_GRID_04: 'section-faq-grid-04',
    FAQ_GRID_05: 'section-faq-grid-05',
    FAQ_GRID_06: 'section-faq-grid-06',
    ICON_WITH_TEXT_SLIDER: 'section-icon-with-text-slider',
    MARQUEE_IMAGE: 'section-marquee-image',
    REVIEW_GRID_KIND_LOKAL: 'section-review-grid-kind-lokal',
    REVIEW_GRID: 'section-review-grid',
    REVIEW_GRID_02: 'section-review-grid-02',
    TEXT_CAROUSEL: 'section-text-carousel',
    TINO_GRID: 'section-tino-grid',
    PRODUCT_REVIEWS: 'section-product-reviews',
    PRODUCT_REVIEWS_02: 'section-product-reviews-02',
    PRODUCT_REVIEWS_03: 'section-product-reviews-03',
    PRODUCT_REVIEWS_04: 'section-product-reviews-04',
    PRODUCT_REVIEWS_05: 'section-product-reviews-05',
    FASTVALUEDEAL_REVIEWS: 'section-fastvaluedeal-reviews',
    PRODUCT_REVIEWS_06: 'section-product-reviews-06',
    COUNT_DOWN_HURRY_BOX: 'section-countdown-hurry-box',
    SIZING_CHART_HURRY_BOX: 'section-sizing-chart-hurry-box',
    ORDER_INFO: 'section-order-info',
    SAINTBRAND_SHIPPING: 'section-saintbrand-shipping',
    TABS_SECTION: 'section-tabs',
    CARD_MEDIA_SLIDER: 'section-card-media-slider',
    CARD_MEDIA_SLIDER_02: 'section-card-media-slider-02',
    CARD_MEDIA_SLIDER_03: 'section-card-media-slider-03',
    CARD_STEP_INSTRUCTIONS: 'section-card-step-instructions',
    ITEMS_GRID_SECTION: 'section-items-grid',
    ITEMS_SLIDE_B1: 'section-items-slide-b1',
    FAQ_CARD: 'section-faq-card',
    BANNER_MEDIA: 'section-banner-media',
    CARD_MULTI_TOOL: 'section-card-multi-tool',
    CARD_MULTI_TOOL_DOUBLE: 'section-card-multi-tool-double',
    REVIEW_TITAN: 'section-review-titan',
    REVIEW_VITAL: 'section-review-vital',
    POLICY_ACCORDION_BASIC: 'section-policy-accordion-basic',
    POLICY_YURI_ACCORDION: 'section-policy-yuri-accordion',
    POLICY_YURI_VIDEOS: 'section-policy-yuri-videos',
    POLICY_YURI_REIVEW: 'section-policy-yuri-reivew',
    FAQ_VITAL: 'section-faq-vital',
    CARD_VITAL_SLIDER: 'section-card-vital-slider',
    CARD_VITAL_SLIDER_02: 'section-card-vital-slider-02',
    CARD_VITAL_TAB: 'section-card-vital-tab',
    CARD_CEDROW_WITH_TAB: 'section-card-cedrow-with-tab',
    CARD_CEDROW_BENEFITS_POLICY: 'section-card-cedrow-benefits-policy',
    REVIEW_GRID_04: 'section-review-grid-04',
    REVIEW_GRID_05: 'section-review-grid-05',
    ITEMS_GRID_MEDIA: 'section-items-grid-media',
    MARQUEE_YURI: 'section-marquee-yuri',
    SLIDER_FASTVALUEDEAL_01: 'section-slider-fastvaluedeal-01',
    CARD_WITH_SLIDER_RIVONEED: 'section-card-with-slider-rivoneed',
    CARD_SLIDER_RIVONEED: 'section-card-slider-rivoneed',
    MARQUEE_RIVONEED: 'section-marquee-rivoneed',
    CARD_FAQ_RIVONEED: 'section-card-faq-rivoneed',
    FASTVALUEDEAL_COUNTDOWN: 'section-fastvaluedeal-countdown',
    FASTVALUEDEAL_FAQ: 'section-fastvaluedeal-faq',
    GATORZ_YOUTUBE: 'section-gatorz-youtube',
    GATORZ_COMPARE_IMAGE: 'section-gatorz-compare-image',
    GATORZ_REVIEWS: 'section-gatorz-reviews',
    SAINTBRAND_REVIEWS: 'section-saintbrand-reviews',
    LOSAPRILY_REVIEWS: 'section-losaprily-reviews',
    GATORZ_SUPPORT: 'section-gatorz-support',
    GATORZ_FRAME_SPECS: 'section-gatorz-frame-specs',
    SUBSCRIBE_EMAIL: 'section-subcribe-email',
    CARD_MEDIA_WITH_SLIDER_LOSAPRILY: 'section-card-media-with-slider-losaprily',
    CARD_TAB_WITH_CONTENT_LOSAPRILY: 'section-card-tab-with-content-losaprily',
    MARQUEE_SHOPZOVYA: 'section-marquee-shopzovya',
    SOWHATBUY_FEATURES_SLIDER: 'section-sowhatbuy-features-slider',
    TRYHER_REVIEW_GRID: 'section-tryher-review-grid',
    TRYHER_GRID_PERCENT: 'section-tryher-grid-percent',
    LEONIEANDCO_REVIEW_GRID: 'section-leonieandco-review-grid',
    UPAIRY_TABS: 'section-upairy-tabs',
    KONFORTIFY_FB: 'section-konfortify-fb',
    KONFORTIFY_REVIEW_GRID: 'section-konfortify-review-grid',
    FURNITURESHOP_GRID_SLIDER: 'section-furnitureshop-grid-slider',
    FURNITURESHOP_GRID_SLIDER_02: 'section-furnitureshop-grid-slider-02',
    FURNITURESHOP_CAROUSEL: 'section-furnitureshop-carousel',
    FURNITURESHOP_FAQ: 'section-furnitureshop-faq',
    MANCHESTORE_COMPARE_SLIDER: 'section-manchestore-compare-slider',
    SOFYRE_TABS_REVIEW: 'section-sofyre-tabs-review',
    SOFYREGRID_TIMELINE: 'section-sofyre-timeline',
    MADAM_SIZE_CALCULATOR: 'section-madam-size-calculator',
  };

  let swiperLoadPromise = null;

  function loadSwiper(callback) {
    if (window.Swiper && typeof window.Swiper === 'function') {
      callback();
      return;
    }

    const existing = document.querySelector('script[data-attribute="script-swiper"]');
    if (existing && existing.dataset.loaded === 'true') {
      callback();
      return;
    }

    if (!swiperLoadPromise) {
      swiperLoadPromise = new Promise((resolve, reject) => {
        const handleLoaded = () => {
          if (existing) {
            existing.dataset.loaded = 'true';
          }
          resolve();
        };

        const handleError = () => {
          reject(new Error('Failed to load swiper script'));
        };

        if (existing) {
          existing.addEventListener('load', handleLoaded, { once: true });
          existing.addEventListener('error', handleError, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.dataset.attribute = 'script-swiper';
        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = handleError;
        document.head.appendChild(script);
      }).finally(() => {
        swiperLoadPromise = null;
      });
    }

    swiperLoadPromise
      .then(() => {
        callback();
      })
      .catch(error => {
        console.error(error);
      });
  }

  function parseYouTubeTimeToSeconds(value) {
    if (!value) return null;

    if (/^\d+$/.test(value)) return parseInt(value, 10);

    const match = value.match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/i);
    if (!match) return null;

    const hours = parseInt(match[1] || '0', 10);
    const minutes = parseInt(match[2] || '0', 10);
    const seconds = parseInt(match[3] || '0', 10);
    const total = hours * 3600 + minutes * 60 + seconds;

    return total > 0 ? total : null;
  }

  function normalizeYoutubeEmbedUrl(rawUrl) {
    if (!rawUrl) return '';

    try {
      const url = new URL(rawUrl, window.location.origin);
      const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
      let videoId = '';

      if (hostname === 'youtu.be') {
        videoId = url.pathname.split('/').filter(Boolean)[0] || '';
      } else if (hostname.endsWith('youtube.com') || hostname.endsWith('youtube-nocookie.com')) {
        if (url.pathname.startsWith('/embed/')) {
          videoId = url.pathname.split('/')[2] || '';
        } else if (url.pathname.startsWith('/shorts/')) {
          videoId = url.pathname.split('/')[2] || '';
        } else {
          videoId = url.searchParams.get('v') || '';
        }
      }

      if (!videoId) return rawUrl;

      const embedUrl = new URL(`https://www.youtube-nocookie.com/embed/${videoId}`);
      if (url.searchParams.get('autoplay') === '1') {
        embedUrl.searchParams.set('autoplay', '1');
      }
      const startValue = url.searchParams.get('start') || url.searchParams.get('t');
      const startSeconds = parseYouTubeTimeToSeconds(startValue);
      if (startSeconds) {
        embedUrl.searchParams.set('start', String(startSeconds));
      }

      return embedUrl.toString();
    } catch (_error) {
      return rawUrl;
    }
  }

  function isYoutubeUrl(urlValue) {
    if (!urlValue) return false;
    try {
      const url = new URL(urlValue, window.location.origin);
      const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
      return hostname === 'youtu.be' || hostname.endsWith('youtube.com') || hostname.endsWith('youtube-nocookie.com');
    } catch (_error) {
      return false;
    }
  }

  function buildGatorzYoutubeEmbedUrl(rawUrl) {
    if (!rawUrl || !isYoutubeUrl(rawUrl)) return '';

    try {
      const embedUrl = new URL(normalizeYoutubeEmbedUrl(rawUrl));
      const videoId = embedUrl.pathname
        .split('/')
        .filter(Boolean)
        .pop();
      if (!videoId) return embedUrl.toString();

      embedUrl.searchParams.set('autoplay', '1');
      embedUrl.searchParams.set('mute', '1');
      embedUrl.searchParams.set('loop', '1');
      embedUrl.searchParams.set('controls', '0');
      embedUrl.searchParams.set('modestbranding', '1');
      embedUrl.searchParams.set('rel', '0');
      embedUrl.searchParams.set('playsinline', '1');
      embedUrl.searchParams.set('disablekb', '1');
      embedUrl.searchParams.set('fs', '0');
      embedUrl.searchParams.set('iv_load_policy', '3');
      embedUrl.searchParams.set('enablejsapi', '1');
      if (window.location?.origin) {
        embedUrl.searchParams.set('origin', window.location.origin);
      }
      return embedUrl.toString();
    } catch (_error) {
      return normalizeYoutubeEmbedUrl(rawUrl);
    }
  }

  function getAccordionPrimaryIconSvg(type, open) {
    const chevronUpIconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>';
    const chevronDownIconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
    const plusIconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
    const minusIconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>';
    const closeIconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

    switch (type) {
      case 'chevron-down-up':
        return open ? chevronUpIconSvg : chevronDownIconSvg;
      case 'plus-minus':
        return open ? minusIconSvg : plusIconSvg;
      case 'plus-close':
        return open ? closeIconSvg : plusIconSvg;
      default:
        return open ? minusIconSvg : plusIconSvg;
    }
  }

  function updateAccordionPrimaryIcon(accordionEl, open) {
    const iconEl = accordionEl.querySelector('[data-attribute="accordion-icon"]');
    if (!iconEl) return;

    const iconType = accordionEl.getAttribute('data-icon-type') || 'plus-minus';
    const iconShow = accordionEl.getAttribute('data-icon-show') !== 'false';
    iconEl.style.display = iconShow ? 'flex' : 'none';
    iconEl.innerHTML = getAccordionPrimaryIconSvg(iconType, open);
  }

  /*
   * Init accordion primary
   * @param {HTMLElement} rootElement - The root element of the section
   * @param {object} [options]
   * @param {number} [options.animationDuration=400] - Delay before onExpand callback (ms)
   * @param {Function} [options.onExpand] - Callback after expand animation
   */
  function initAccordionPrimary(rootElement, options = {}) {
    if (!rootElement) return;

    const accordionPrimaryEl = rootElement.querySelector('[data-attribute="accordion-primary-title"]');
    if (!accordionPrimaryEl || accordionPrimaryEl.dataset.accordionInitialized === '1') return;

    const accordionPrimaryContentEl = rootElement.querySelector('[data-attribute="accordion-primary-content"]');
    if (!accordionPrimaryContentEl) return;

    const animationDuration = options.animationDuration ?? 400;

    const setExpanded = expanded => {
      accordionPrimaryEl.setAttribute('data-open', expanded ? 'true' : 'false');
      accordionPrimaryContentEl.classList.toggle('is-accordion-primary-collapsed', !expanded);
      accordionPrimaryEl.style.display = 'flex';
      updateAccordionPrimaryIcon(accordionPrimaryEl, expanded);

      if (expanded && typeof options.onExpand === 'function') {
        window.setTimeout(() => options.onExpand(accordionPrimaryEl, accordionPrimaryContentEl), animationDuration);
      }
    };

    setExpanded(accordionPrimaryEl.getAttribute('data-open') !== 'false');

    accordionPrimaryEl.style.cursor = 'pointer';
    accordionPrimaryEl.addEventListener('click', () => {
      const expanded = accordionPrimaryEl.getAttribute('data-open') === 'true';
      setExpanded(!expanded);
    });

    accordionPrimaryEl.dataset.accordionInitialized = '1';
  }

  let productReviewsImageModalCloseInstalled = false;

  const helperFunctions = {
    cardVideoSlider: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      const listItemWrap = container.querySelector('[data-attribute="list-item"]');
      const autoPlayVideo = listItemWrap?.getAttribute('data-auto-play-video') === 'true';
      const forceMuted = listItemWrap?.getAttribute('data-muted') === 'true';
      const videos = container.querySelectorAll('.wrap-item video');

      videos.forEach(video => {
        const wrap = video.closest('.wrap-item');
        const playBtn = wrap.querySelector('.playvideo');
        const volumeWrap = wrap.querySelector('.volume');
        const volumeIcon = volumeWrap?.querySelector('.volume-icon');
        const muteIcon = volumeWrap?.querySelector('.mute-icon');

        if (video.dataset.initialized) return;
        video.dataset.initialized = true;

        video.muted = true;
        if (volumeWrap) {
          volumeWrap.style.display = forceMuted ? 'none' : 'flex';
        }

        function togglePlay() {
          if (video.paused) {
            video
              .play()
              .then(() => {
                if (playBtn) playBtn.style.display = 'none';
              })
              .catch(error => {
                console.warn('Autoplay block:', error);
              });
          } else {
            video.pause();
            if (playBtn) playBtn.style.display = 'flex';
          }
        }

        video.removeEventListener('click', togglePlay);
        video.addEventListener('click', togglePlay);

        if (playBtn) {
          playBtn.addEventListener('click', event => {
            event.stopPropagation();
            togglePlay();
          });
        }

        video.addEventListener('ended', () => {
          if (playBtn) playBtn.style.display = 'flex';
        });

        if (autoPlayVideo) {
          video.play().catch(error => {
            console.warn('Autoplay block:', error);
          });
          if (playBtn) playBtn.style.display = 'none';
        } else if (playBtn) {
          playBtn.style.display = 'flex';
        }

        // data-muted=true: lock muted state and hide volume controls.
        if (forceMuted) return;

        // Only unmute when user explicitly clicks the volume icon.
        if (volumeIcon) {
          volumeIcon.addEventListener('click', event => {
            event.stopPropagation();
            if (video.paused) {
              video.play().catch(() => {});
            }
            video.muted = false;
            volumeIcon.style.display = 'none';
            if (muteIcon) muteIcon.style.display = 'flex';
          });
        }

        if (muteIcon) {
          muteIcon.addEventListener('click', event => {
            event.stopPropagation();
            video.muted = true;
            if (volumeIcon) volumeIcon.style.display = 'flex';
            muteIcon.style.display = 'none';
          });
        }
      });

      if (window.Swiper && typeof window.Swiper === 'function') {
        // Get breakpoints from section element or use defaults
        const sectionEl = container.closest('section[data-type="section-card-video-slider"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 5;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 5;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: {
            spaceBetween: '30px',
            slidesPerView: desktopSlides,
          },
        };

        new window.Swiper(`.swiper-video-${uniqueId}`, {
          // observer: true,
          // observeParents: true,
          slidesPerView: mobileSlides,
          spaceBetween: 15,
          loop: false,
          navigation: {
            nextEl: `.next-${uniqueId}`,
            prevEl: `.prev-${uniqueId}`,
          },
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    marqueeTino: uniqueId => {
      const isSection = document.querySelector(`#card-container-${uniqueId}`);
      if (isSection) {
        const elListItem = isSection.querySelector('[data-attribute="list-item"]');
        elListItem.innerHTML = Array(12)
          .fill(elListItem.innerHTML)
          .join('');
      }
    },

    markqueueRows: uniqueId => {
      const isSection = document.querySelector(`#card-container-${uniqueId}`);
      if (!isSection) return;

      const elRows = isSection.querySelectorAll('[data-attribute="row-markqueue"]');
      elRows.forEach(row => {
        if (row.getAttribute('data-markqueue-duplicated') === 'true') return;
        row.innerHTML = Array(12)
          .fill(row.innerHTML)
          .join('');
        row.setAttribute('data-markqueue-duplicated', 'true');
      });
    },
    fbPost03Section: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.wrap-slider-post-items .swiper');
      if (!swiperEl) return;
      if (swiperEl.swiper) return;

      const listPostEl = container.querySelector('[data-attribute="list-post"]');
      const desktopPerView = parseInt(listPostEl?.getAttribute('data-col-per-view') || '3', 10) || 3;

      new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: 2 },
          1024: { slidesPerView: desktopPerView, spaceBetween: 20 },
        },
        navigation: {
          nextEl: `#card-container-${uniqueId} .swiper-button-next`,
          prevEl: `#card-container-${uniqueId} .swiper-button-prev`,
        },
      });
    },

    bannerSlider: uniqueId => {
      if (window.Swiper && typeof window.Swiper === 'function') {
        new window.Swiper(`.mySwiperBannerSlider-${uniqueId}`, {
          slidesPerView: 1,
          spaceBetween: 15,
          pagination: {
            el: '.mySwiperBannerSlider-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
        });
      }
    },
    cardSliderYuri: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.wrap-slider .swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const paginationEl = container.querySelector('.wrap-slider .swiper-pagination');

      const listItemWrap = container.querySelector('[data-attribute="list-item"]');
      const desktopPerView = parseFloat(listItemWrap?.getAttribute('data-col-per-view') || '3') || 3;

      new window.Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 8,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: Math.min(2, desktopPerView), spaceBetween: 10 },
          768: { slidesPerView: Math.min(3, desktopPerView), spaceBetween: 12 },
          1024: { slidesPerView: desktopPerView, spaceBetween: 12 },
        },
      });
    },
    sliderFastvaluedeal01: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.wrap-list-items .swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const listItemWrap = container.querySelector('[data-attribute="list-item"]');
      const colPerView = parseFloat(listItemWrap?.getAttribute('data-col-per-view') || '4') || 4;
      const spaceBetween = parseFloat(listItemWrap?.getAttribute('data-space-between') || '20') || 20;

      const paginationEl = container.querySelector('.wrap-pagination .swiper-pagination');
      const nextEl = container.querySelector('.wrap-pagination .swiper-button-next');
      const prevEl = container.querySelector('.wrap-pagination .swiper-button-prev');

      new window.Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween,
        ...(paginationEl ? { pagination: { el: paginationEl, clickable: true } } : {}),
        ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: Math.min(2, colPerView), spaceBetween },
          768: { slidesPerView: Math.min(3, colPerView), spaceBetween },
          1024: { slidesPerView: colPerView, spaceBetween },
        },
      });
    },
    cardWithSliderRivoneed: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.block-slider .swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const paginationEl = container.querySelector('.block-slider .swiper-pagination');
      const nextEl = container.querySelector('.block-slider .swiper-button-next');
      const prevEl = container.querySelector('.block-slider .swiper-button-prev');

      new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        ...(paginationEl ? { pagination: { el: paginationEl, clickable: true } } : {}),
        ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
      });
    },
    cardMediaWithSliderLosaprily: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.block-swiper .swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const paginationEl = container.querySelector('.block-swiper .swiper-pagination');

      const getSwiperConfig = width => {
        if (width >= 769) {
          return {
            direction: 'vertical',
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            mousewheel: true,
            centeredSlides: false,
            speed: 1000,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
          };
        } else {
          return {
            direction: 'horizontal',
            slidesPerView: 1.2,
            spaceBetween: 16,
            loop: false,
            mousewheel: false,
            centeredSlides: false,
          };
        }
      };

      const initialWidth = container.offsetWidth || window.innerWidth;
      const initialConfig = getSwiperConfig(initialWidth);

      const swiper = new window.Swiper(swiperEl, {
        ...initialConfig,
        ...(paginationEl ? { pagination: { el: paginationEl, clickable: true } } : {}),
      });

      if (typeof window.ResizeObserver !== 'undefined') {
        let lastWidth = initialWidth;
        const resizeObserver = new window.ResizeObserver(entries => {
          for (let entry of entries) {
            const width = entry.contentRect.width;
            const wasDesktop = lastWidth >= 769;
            const isDesktop = width >= 769;

            if (wasDesktop !== isDesktop) {
              lastWidth = width;
              const newConfig = getSwiperConfig(width);

              if (typeof swiper.changeDirection === 'function') {
                swiper.changeDirection(newConfig.direction, false);
              }
              swiper.params.slidesPerView = newConfig.slidesPerView;
              swiper.params.spaceBetween = newConfig.spaceBetween;

              if (swiper.mousewheel) {
                if (newConfig.mousewheel) {
                  swiper.mousewheel.enable();
                } else {
                  swiper.mousewheel.disable();
                }
              }

              swiper.update();
            }
          }
        });
        resizeObserver.observe(container);
      }
    },
    cardTabWithContentLosaprily: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const headingItems = container.querySelectorAll('[data-attribute="tab-heading-item"]');
      const bgItems = container.querySelectorAll('[data-attribute="tab-images-bg-item"]');
      const contentItems = container.querySelectorAll('[data-attribute="tab-content-item"]');

      headingItems.forEach(headingEl => {
        headingEl.addEventListener('click', () => {
          const tabId = headingEl.getAttribute('data-tab');
          if (!tabId) return;

          // Toggle heading items active class
          headingItems.forEach(el => {
            if (el.getAttribute('data-tab') === tabId) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }
          });

          // Toggle background items active class
          bgItems.forEach(el => {
            if (el.getAttribute('data-tab') === tabId) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }
          });

          // Toggle content items active class
          contentItems.forEach(el => {
            if (el.getAttribute('data-tab') === tabId) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }
          });
        });
      });
    },
    cardSliderRivoneed: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const runSwiper = () => {
        const paginationEl = container.querySelector('.swiper-pagination');
        const nextEl = container.querySelector('.swiper-button-next');
        const prevEl = container.querySelector('.swiper-button-prev');

        new window.Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 10,
          initialSlide: 1,
          loop: true,
          loopAdditionalSlides: 2,
          speed: 1000,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          pagination: { el: paginationEl, clickable: true },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          breakpointsBase: 'container',
          breakpoints: {
            769: {
              spaceBetween: 30,
            },
          },
        });
      };
      const cloneX6ItemSlider = () => {
        const wrapItemEl = container.querySelector('[data-attribute="list-item"]');
        const listItem = container.querySelectorAll('.swiper-slide');

        const lengthItem = Array.from(listItem).length;

        if (lengthItem >= 6) return;
        let xClone = 6 - lengthItem;
        for (let i = 0; i < xClone; i++) {
          const targetItem = listItem[i % lengthItem];

          if (targetItem) {
            const cloneItem = targetItem.cloneNode(true);
            wrapItemEl.appendChild(cloneItem);
          }
        }
      };
      cloneX6ItemSlider();
      runSwiper();
    },
    marqueeRivoneed: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const blockMarqueeEl = container.querySelector('[data-attribute="block-marquee"]');
      const listItemEl = blockMarqueeEl?.querySelector('[data-attribute="list-item"]');
      if (!blockMarqueeEl || !listItemEl) return;

      const itemEls = listItemEl.querySelectorAll('[data-attribute="item-marquee"]');
      const lengthItem = Array.from(itemEls).length;
      if (!lengthItem) return;

      if (lengthItem < 10) {
        const xClone = 10 - lengthItem;
        for (let i = 0; i < xClone; i++) {
          const targetItem = itemEls[i % lengthItem];

          if (targetItem) {
            const cloneItem = targetItem.cloneNode(true);
            listItemEl.appendChild(cloneItem);
          }
        }
      }

      const listItemEls = Array.from(blockMarqueeEl.children).filter(
        el => el.getAttribute('data-attribute') === 'list-item',
      );
      if (listItemEls.length < 2) {
        const cloneListItemEl = listItemEl.cloneNode(true);
        cloneListItemEl.setAttribute('data-cloned-marquee', 'true');
        blockMarqueeEl.appendChild(cloneListItemEl);
      }
    },
    marqueeShopzovya: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const rowMarqueeEls = container.querySelectorAll('[data-attribute="row-marquee"]');
      rowMarqueeEls.forEach(rowMarqueeEl => {
        const listItemEl = rowMarqueeEl.querySelector('.list-item');
        if (!listItemEl) return;

        const itemEls = listItemEl.querySelectorAll('[data-attribute="marquee-item"]');
        const lengthItem = Array.from(itemEls).length;
        if (!lengthItem) return;

        if (lengthItem < 10) {
          const xClone = 10 - lengthItem;
          for (let i = 0; i < xClone; i++) {
            const targetItem = itemEls[i % lengthItem];

            if (targetItem) {
              const cloneItem = targetItem.cloneNode(true);
              listItemEl.appendChild(cloneItem);
            }
          }
        }

        const listItemEls = Array.from(rowMarqueeEl.children).filter(el => el.classList.contains('list-item'));
        if (listItemEls.length < 2) {
          const cloneListItemEl = listItemEl.cloneNode(true);
          cloneListItemEl.setAttribute('data-cloned-marquee', 'true');
          rowMarqueeEl.appendChild(cloneListItemEl);
        }
      });
    },
    reviewSliderYuriSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const productReviewBlock = container.querySelector('[data-attribute="product-review"]');
      const insertProductReviewEls = container.querySelectorAll('[data-attribute="insert-product-reivew"]');

      if (productReviewBlock && insertProductReviewEls.length > 0) {
        const productReviewHtml = productReviewBlock.innerHTML || '';
        insertProductReviewEls.forEach(el => {
          const purchaseDate = (el.getAttribute('data-purchase-date') || '').trim();
          const wrapper = document.createElement('div');
          wrapper.innerHTML = productReviewHtml;
          const purchaseDateEl = wrapper.querySelector('[data-attribute="purchase-date"]');
          if (purchaseDateEl) {
            purchaseDateEl.textContent = purchaseDate;
          }
          el.innerHTML = wrapper.innerHTML;
        });
        productReviewBlock.style.display = 'none';
      }

      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.wrap-review-slider .swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const paginationEl = container.querySelector('.wrap-review-slider .swiper-pagination');
      const listItemWrap = container.querySelector('[data-attribute="list-item"]');
      const desktopPerView = parseFloat(listItemWrap?.getAttribute('data-col-per-view') || '3') || 3;
      const spaceBetween = parseFloat(listItemWrap?.getAttribute('data-space-between') || '16') || 16;

      new window.Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: Math.min(2, desktopPerView), spaceBetween },
          768: { slidesPerView: Math.min(3, desktopPerView), spaceBetween },
          1024: { slidesPerView: desktopPerView, spaceBetween },
        },
      });
    },

    cardAccordions: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('.accordion-icon').forEach(icon => {
            icon.classList.remove('open');
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('.accordion-icon').classList.add('open');
          }
        });
      });
    },

    cardCompareTwoImage: uniqueId => {
      const containerInViewTPL = document.querySelector('#view-section-template');
      const container = containerInViewTPL
        ? containerInViewTPL.querySelector(`[data-attribute='card-container-${uniqueId}']`)
        : document.querySelector(`[data-attribute='card-container-${uniqueId}']`);

      if (!container) return;

      const x = container.querySelector('.img-comp-overlay');
      const containerX = container.querySelector('.img-comp-container');
      if (!x || !containerX) return;

      compareImages(x, containerX);

      function compareImages(img, containerX) {
        let slider;
        let clicked = 0;
        const w = containerX.offsetWidth;

        img.style.width = w / 2 + 'px';

        slider = container.querySelector('.img-comp-slider');
        if (!slider) return;

        slider.style.left = w / 2 - slider.offsetWidth / 2 + 'px';

        slider.addEventListener('mousedown', slideReady);
        window.addEventListener('mouseup', slideFinish);
        slider.addEventListener('touchstart', slideReady);
        window.addEventListener('touchend', slideFinish);

        function slideReady(e) {
          e.preventDefault();
          clicked = 1;
          window.addEventListener('mousemove', slideMove);
          window.addEventListener('touchmove', slideMove);
        }

        function slideFinish() {
          clicked = 0;
        }

        function slideMove(e) {
          if (!clicked) return;
          let pos = getCursorPos(e);
          pos = Math.max(0, Math.min(pos, w));
          slide(pos);
        }

        function getCursorPos(e) {
          const evt = e.changedTouches ? e.changedTouches[0] : e;
          const rect = img.getBoundingClientRect();
          let x = evt.pageX - rect.left - window.pageXOffset;
          return x;
        }

        function slide(x) {
          img.style.width = x + 'px';
          slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + 'px';
        }
      }
    },

    cardCompareYuri: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);

      if (!container) return;

      const x = container.querySelector('.img-comp-overlay');
      const containerX = container.querySelector('.img-comp-container');
      if (!x || !containerX) return;

      compareImages(x, containerX);

      function compareImages(img, containerX) {
        let slider;
        let clicked = 0;
        const w = containerX.offsetWidth;

        img.style.width = w / 2 + 'px';

        slider = container.querySelector('.img-comp-slider');
        if (!slider) return;

        slider.style.left = w / 2 - slider.offsetWidth / 2 + 'px';

        slider.addEventListener('mousedown', slideReady);
        window.addEventListener('mouseup', slideFinish);
        slider.addEventListener('touchstart', slideReady);
        window.addEventListener('touchend', slideFinish);

        function slideReady(e) {
          e.preventDefault();
          clicked = 1;
          window.addEventListener('mousemove', slideMove);
          window.addEventListener('touchmove', slideMove);
        }

        function slideFinish() {
          clicked = 0;
        }

        function slideMove(e) {
          if (!clicked) return;
          let pos = getCursorPos(e);
          pos = Math.max(0, Math.min(pos, w));
          slide(pos);
        }

        function getCursorPos(e) {
          const evt = e.changedTouches ? e.changedTouches[0] : e;
          const rect = img.getBoundingClientRect();
          let x = evt.pageX - rect.left - window.pageXOffset;
          return x;
        }

        function slide(x) {
          img.style.width = x + 'px';
          slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + 'px';
        }
      }
    },

    cardHaveViewMoreSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('.accordion-icon').forEach(icon => {
            icon.classList.remove('open');
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('.accordion-icon').classList.add('open');
          }
        });
      });
    },

    collapsibleProductGridSection: uniqueId => {
      const sectionRoot = document.querySelector(`.collapsible-product-grid-${uniqueId}`);
      if (!sectionRoot) return;

      // Get all collapsible items
      const items = sectionRoot.querySelectorAll('.collapsible-product-grid-item');

      items.forEach(item => {
        const content = item.querySelector('.collapsible-product-grid-item-content');
        const iconContainer = item.querySelector('.collapsible-product-grid-item-button-icon');
        const buttonText = item.querySelector('.collapsible-product-grid-item-button-text');
        const chevronIcons = iconContainer.querySelectorAll('svg');

        if (!content || !iconContainer || chevronIcons.length < 2) return;

        const downChevron = chevronIcons[0]; // First SVG (down arrow)
        const upChevron = chevronIcons[1]; // Second SVG (up arrow)

        // Initially hide content and show down chevron
        content.style.setProperty('display', 'none', 'important');
        upChevron.style.setProperty('display', 'none', 'important');
        downChevron.style.setProperty('display', 'inline-block', 'important');

        // Add click event listener to the item
        item.addEventListener('click', function(e) {
          e.preventDefault();

          const isExpanded = content.style.display !== 'none';
          const seeMoreText = sectionRoot.getAttribute('data-see-more-text') || 'see more';
          const seeLessText = sectionRoot.getAttribute('data-see-less-text') || 'see less';

          if (isExpanded) {
            // Collapse: Hide content, show down chevron, hide up chevron
            content.style.setProperty('display', 'none', 'important');
            downChevron.style.setProperty('display', 'inline-block', 'important');
            upChevron.style.setProperty('display', 'none', 'important');
            buttonText.textContent = seeMoreText;
          } else {
            // Expand: Show content, hide down chevron, show up chevron
            content.style.setProperty('display', 'block', 'important');
            downChevron.style.setProperty('display', 'none', 'important');
            upChevron.style.setProperty('display', 'inline-block', 'important');
            buttonText.textContent = seeLessText;
          }
        });
      });
    },

    faqGridSection: uniqueId => {
      const container = document.querySelector(`[data-container="faq-grid-container-fluid-${uniqueId}"]`);
      const faqQuestions = container.querySelectorAll('.item-question');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="item-answer"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('[data-attribute="icon-plus"]').forEach(icon => {
            icon.style.display = 'block';
          });
          container.querySelectorAll('[data-attribute="icon-minus"]').forEach(icon => {
            icon.style.display = 'none';
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('[data-attribute="icon-plus"]').style.display = 'none';
            question.querySelector('[data-attribute="icon-minus"]').style.display = 'block';
          }
        });
      });
    },

    iconWithTextSliderSection: uniqueId => {
      if (window.Swiper && typeof window.Swiper === 'function') {
        new window.Swiper('.view-icon-with-text-slider-' + uniqueId + ' .swiperIconWithTextSlider', {
          slidesPerView: 1,
          spaceBetween: 15,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.view-icon-with-text-slider-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpointsBase: 'container',
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        });
      }
    },

    marqueeImageSection: uniqueId => {
      const isSection = document.querySelector(`#card-container-${uniqueId}`);
      if (isSection) {
        const elListItem = isSection.querySelector('[data-attribute="list-item"]');
        elListItem.innerHTML = Array(12)
          .fill(elListItem.innerHTML)
          .join('');
      }
    },

    marqueeYuriSection: uniqueId => {
      const isSection = document.querySelector(`#card-container-${uniqueId}`);
      if (isSection) {
        const elListItem = isSection.querySelector('[data-attribute="list-item"]');
        elListItem.innerHTML = Array(12)
          .fill(elListItem.innerHTML)
          .join('');
      }
    },

    reviewGridKindLokalSection: uniqueId => {
      if (window.Swiper && typeof window.Swiper === 'function') {
        const wrapper = document.querySelector('.review-grid-kind-lokal-wrapper-' + uniqueId);
        if (!wrapper) return;

        // Get breakpoints from section element or use defaults
        const sectionEl = wrapper.closest('section[data-type="section-review-grid-kind-lokal"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper('.review-grid-kind-lokal-wrapper-' + uniqueId + ' .swiper', {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          pagination: {
            el: '.review-grid-kind-lokal-wrapper-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    reviewGridSection: uniqueId => {
      const reviewContainer = document.querySelector('.review-grid-wrapper-' + uniqueId);
      if (!reviewContainer) return;

      const showMoreBtns = reviewContainer.querySelectorAll('.show-more-btn');

      // Get global settings
      const moreText = reviewContainer.getAttribute('data-show-more-text') || 'Show more';
      const lessText = reviewContainer.getAttribute('data-show-less-text') || 'Show less';
      const lineClamp = parseInt(reviewContainer.getAttribute('data-line-clamp')) || 4;

      // Apply line-clamp to all review content
      const reviewContents = reviewContainer.querySelectorAll('.review-content p');
      reviewContents.forEach(content => {
        content.style.webkitLineClamp = lineClamp;
        content.style.lineClamp = lineClamp;
      });

      // Initialize button labels
      showMoreBtns.forEach(btn => {
        btn.textContent = moreText;
      });

      // Show more/less toggle
      showMoreBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          const reviewCard = this.closest('.review-card');
          const content = reviewCard.querySelector('.review-content');

          if (content.classList.contains('expanded')) {
            content.classList.remove('expanded');
            this.textContent = moreText;
          } else {
            content.classList.add('expanded');
            this.textContent = lessText;
          }
        });
      });

      if (window.Swiper && typeof window.Swiper === 'function') {
        // Get breakpoints from section element or use defaults
        const sectionEl = reviewContainer.closest('section[data-type="section-review-grid"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper('.review-grid-wrapper-' + uniqueId + ' .swiper', {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          uniqueNavElements: true,
          pagination: {
            el: '.review-grid-wrapper-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    reviewGrid02Section: uniqueId => {
      const reviewContainer = document.querySelector('.review-grid-wrapper-' + uniqueId);
      if (!reviewContainer) return;

      const wrapArrows = reviewContainer.querySelector('.wrap-arrows');
      if (wrapArrows) {
        wrapArrows.querySelectorAll('svg').forEach(svg => {
          svg.addEventListener('click', e => {
            e.preventDefault();
            const target = e.target;
            if (target.classList.contains('arrow-left')) {
              reviewContainer.querySelector('.swiper').swiper.slidePrev();
            }
            if (target.classList.contains('arrow-right')) {
              reviewContainer.querySelector('.swiper').swiper.slideNext();
            }
          });
        });
      }

      if (window.Swiper && typeof window.Swiper === 'function') {
        // Get breakpoints from section element or use defaults
        const sectionEl = reviewContainer.closest('section[data-type="section-review-grid-02"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper('.review-grid-wrapper-' + uniqueId + ' .swiper', {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          uniqueNavElements: true,
          loop: true,
          navigation: {
            nextEl: '.review-grid-wrapper-' + uniqueId + ' .arrow-right',
            prevEl: '.review-grid-wrapper-' + uniqueId + ' .arrow-left',
          },
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    tinoGrid: uniqueId => {
      if (window.Swiper && typeof window.Swiper === 'function') {
        const wrapper = document.querySelector('.tino-grid-wrapper-' + uniqueId);
        if (!wrapper) return;

        // Get breakpoints from section element or use defaults
        const sectionEl = wrapper.closest('section[data-type="section-tino-grid"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          // Handle new format (mobile, tablet, desktop)
          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper('.tino-grid-wrapper-' + uniqueId + ' .swiper', {
          slidesPerView: mobileSlides,
          spaceBetween: 8,
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    textCarousel: uniqueId => {
      if (window.Swiper && typeof window.Swiper === 'function') {
        const wrapper = document.querySelector('.text-carousel-section-' + uniqueId);
        if (!wrapper) return;

        // Get breakpoints from section element or use defaults
        const sectionEl = wrapper.closest('section[data-type="section-text-carousel"]');
        let mobileSlides = 1;
        let tabletSlides = 1;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 1;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper('.text-carousel-section-' + uniqueId + ' .mySwiperTextCarousel', {
          slidesPerView: mobileSlides,
          spaceBetween: 15,
          centeredSlides: true,
          initialSlide: 1,
          loop: true,
          uniqueNavElements: true,
          pagination: {
            el: '.text-carousel-section-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    productReviews: uniqueId => {
      const rootElement = document.querySelector('.product-reviews-wrapper-' + uniqueId);
      if (!rootElement) return;

      // Setup image modal
      if (!productReviewsImageModalCloseInstalled) {
        productReviewsImageModalCloseInstalled = true;
        window.closeImageModal = function closeImageModal() {
          document.querySelectorAll('.modal-preview-image').forEach(modal => {
            const display = modal.style.display;
            if (display !== 'flex' && display !== 'block') return;
            const img = modal.querySelector('img[data-attribute="modal-preview-image"]') || modal.querySelector('img');
            modal.style.display = 'none';
            if (img) img.src = '';
          });
        };
      }

      const sectionEl = rootElement.closest('section[data-type]');
      const sectionType = sectionEl ? sectionEl.getAttribute('data-type') : '';
      const flexDisplayTypes = [
        scriptSectionType.PRODUCT_REVIEWS_02,
        scriptSectionType.PRODUCT_REVIEWS_03,
        scriptSectionType.PRODUCT_REVIEWS_05,
        scriptSectionType.FASTVALUEDEAL_REVIEWS,
        scriptSectionType.SAINTBRAND_REVIEWS,
        scriptSectionType.LOSAPRILY_REVIEWS,
      ];
      const visibleDisplay = flexDisplayTypes.includes(sectionType) ? 'flex' : 'block';

      const sectionWrapper = sectionEl || rootElement.parentElement;
      const nextSib = rootElement.nextElementSibling;
      const modalFromSibling = nextSib && nextSib.classList.contains('modal-preview-image') ? nextSib : null;
      const modal =
        modalFromSibling || (sectionWrapper && sectionWrapper.querySelector('.modal-preview-image')) || null;
      const modalImg = modal
        ? modal.querySelector('img[data-attribute="modal-preview-image"]') || modal.querySelector('img')
        : null;

      // Open image modal
      function openImageModal(src) {
        if (modal && modalImg) {
          modalImg.src = src;
          modal.style.display = 'flex';
        }
      }

      // Handle click on review image item
      rootElement.addEventListener('click', e => {
        const imageItem = e.target.closest('.review-image-item');
        if (imageItem) {
          const imgEl = e.target.tagName === 'IMG' ? e.target : imageItem.querySelector('img');
          if (imgEl && imgEl.src) {
            openImageModal(imgEl.src);
          }
        }
      });

      // Get reviews container
      const reviewsContainer = rootElement.querySelector('.reviews-container');
      const loadMoreBtn = rootElement.querySelector('[data-attribute="load-more-btn"]');
      const sectionTypesWithSlides = [scriptSectionType.GATORZ_REVIEWS];
      const sectionTypesWithShowPhotos = [scriptSectionType.PRODUCT_REVIEWS_06];
      const sectionTypesWithLikeDislike = [scriptSectionType.PRODUCT_REVIEWS_06, scriptSectionType.GATORZ_REVIEWS];

      if (!reviewsContainer) return;

      // Render review item
      if (sectionTypesWithSlides.includes(sectionType)) {
        const swiperSelector = `.product-reviews-wrapper-${uniqueId}`;

        const initGatorzReviewsSwiper = () => {
          if (!window.Swiper || typeof window.Swiper !== 'function') return;
          const swiperEl = rootElement.querySelector('.reviews-container.swiper');
          if (!swiperEl || swiperEl.dataset.swiperInitialized === '1') return;
          if (!swiperEl.querySelectorAll('.swiper-slide').length) return;

          new window.Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
              nextEl: `${swiperSelector} .swiper-button-next`,
              prevEl: `${swiperSelector} .swiper-button-prev`,
            },
            breakpointsBase: 'container',
            breakpoints: {
              640: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 4,
              },
            },
          });

          swiperEl.dataset.swiperInitialized = '1';
        };

        initGatorzReviewsSwiper();

        initAccordionPrimary(rootElement, {
          onExpand: () => {
            const swiperEl = rootElement.querySelector('.reviews-container.swiper');
            if (swiperEl?.swiper) {
              swiperEl.swiper.update();
            }
          },
        });
      } else {
        const allReviewItems = Array.from(reviewsContainer.querySelectorAll('.review-item'));
        const loadMoreContainer = rootElement.querySelector('.load-more-container');

        const loadMoreLimit = loadMoreBtn ? parseInt(loadMoreBtn.getAttribute('data-limit')) || 5 : 0;
        let displayedCount = loadMoreBtn ? Math.min(loadMoreLimit, allReviewItems.length) : allReviewItems.length;

        const updateReviewsDisplay = () => {
          allReviewItems.forEach((item, index) => {
            item.style.display = index < displayedCount ? visibleDisplay : 'none';
          });

          if (loadMoreContainer) {
            loadMoreContainer.style.display = loadMoreBtn && displayedCount < allReviewItems.length ? 'block' : 'none';
          }

          // Remove padding bottom and border bottom for the last review item (only for section 06)
          if (sectionType === scriptSectionType.PRODUCT_REVIEWS_06) {
            const items = rootElement.querySelectorAll('.review-item');
            const matched = Array.from(items).filter(item => {
              return item.style.display === 'block';
            });
            if (matched.length > 0) {
              const last = matched[matched.length - 1];
              last.style.paddingBottom = '0';
              last.style.borderBottom = 'none';
            }
          }
        };
        updateReviewsDisplay();

        const handleLoadMore = () => {
          if (!loadMoreBtn) return;
          const increment = parseInt(loadMoreBtn.getAttribute('data-limit')) || 5;
          displayedCount = Math.min(displayedCount + increment, allReviewItems.length);
          updateReviewsDisplay();
        };
        if (loadMoreBtn) {
          loadMoreBtn.addEventListener('click', handleLoadMore);
        }
      }

      // Handle like dislike
      if (sectionTypesWithLikeDislike.includes(sectionType)) {
        rootElement.addEventListener('click', e => {
          const clickedLike = e.target.closest('[data-attribute="like-btn"]');
          const clickedDislike = e.target.closest('[data-attribute="dislike-btn"]');
          if (!clickedLike && !clickedDislike) return;

          const reviewItem = (clickedLike || clickedDislike).closest('.review-item');
          if (!reviewItem) return;

          const likeBtn = reviewItem.querySelector('[data-attribute="like-btn"]');
          const dislikeBtn = reviewItem.querySelector('[data-attribute="dislike-btn"]');
          if (!likeBtn || !dislikeBtn) return;

          const likeCountEl = likeBtn.querySelector('.review-helpful-item-count');
          const dislikeCountEl = dislikeBtn.querySelector('.review-helpful-item-count');
          if (!likeCountEl || !dislikeCountEl) return;

          let likeCount = parseInt(likeCountEl.textContent) || 0;
          let dislikeCount = parseInt(dislikeCountEl.textContent) || 0;

          const current = reviewItem.dataset.userReaction || '';
          const next = clickedLike ? (current === 'like' ? '' : 'like') : current === 'dislike' ? '' : 'dislike';

          if (current === next) return;

          if (current === 'like') likeCount = Math.max(0, likeCount - 1);
          if (current === 'dislike') dislikeCount = Math.max(0, dislikeCount - 1);

          if (next === 'like') likeCount += 1;
          if (next === 'dislike') dislikeCount += 1;

          reviewItem.dataset.userReaction = next;
          likeCountEl.textContent = String(likeCount);
          dislikeCountEl.textContent = String(dislikeCount);
        });
      }

      // Handle show customer photos
      if (sectionTypesWithShowPhotos.includes(sectionType)) {
        const images = Array.from(rootElement.querySelectorAll('.review-image-item img')).filter(img => img?.src);
        if (!images.length) {
          const customerImages = rootElement.querySelector('[data-attribute="customer-images"]');
          customerImages.style.display = 'none';
          const customerImagesContainer = rootElement.querySelector('[data-attribute="customer-images-container"]');
          customerImagesContainer.style.justifyContent = 'flex-end';
          return;
        }

        const customerImagesContainer = rootElement.querySelector('[data-attribute="customer-images-grid"]');
        if (!customerImagesContainer) return;

        const maxVisible = 2;
        const visibleImages = images.slice(0, maxVisible);
        const remaining = Math.max(0, images.length - maxVisible);

        customerImagesContainer.innerHTML =
          visibleImages
            .map(
              (img, index) => `
                <div class="customer-image-item" data-index="${index}">
                  <img src="${img.src}" alt="customer-photo-${index + 1}" />
                </div>
              `,
            )
            .join('') +
          (remaining > 0
            ? `
              <div class="customer-image-item customer-image-item--more" data-index="${maxVisible}">
                <img src="${images[maxVisible].src}" alt="customer-photo-${maxVisible + 1}" />
                <div class="customer-image-item-more-overlay">+ ${remaining}</div>
              </div>
            `
            : '');

        if (!customerImagesContainer.dataset.boundClick) {
          customerImagesContainer.dataset.boundClick = '1';
          customerImagesContainer.addEventListener('click', e => {
            const imgEl = e.target && e.target.tagName === 'IMG' ? e.target : e.target.closest('img');
            if (imgEl && imgEl.src) openImageModal(imgEl.src);
          });
        }
      }
    },

    countdownHurryBox: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) {
        return;
      }

      let script = document.currentScript;
      let root = script
        ? script.closest('section[data-type="section-countdown-hurry-box"]')
        : container.closest('section[data-type="section-countdown-hurry-box"]');

      if (!root) {
        return;
      }

      if (root.dataset.executed) {
        return;
      }
      root.dataset.executed = '1';

      const lastMinuteSaleEndIn = root.querySelector('[data-attribute="last-minute-sale-end-in"]');
      if (!lastMinuteSaleEndIn) {
        return;
      }

      const minute = lastMinuteSaleEndIn.querySelector('[data-attribute="minute"]');
      const second = lastMinuteSaleEndIn.querySelector('[data-attribute="second"]');

      let totalSeconds = parseInt(lastMinuteSaleEndIn.getAttribute('data-value'), 10);
      if (isNaN(totalSeconds)) {
        return;
      }
      totalSeconds *= 60;

      const tick = () => {
        const m = Math.floor(totalSeconds / 60);
        const s = totalSeconds % 60;
        minute.textContent = String(m).padStart(2, '0');
        second.textContent = String(s).padStart(2, '0');
        if (totalSeconds <= 0) {
          clearInterval(timer);
        } else {
          totalSeconds--;
        }
      };

      tick();
      const timer = setInterval(tick, 1000);

      const observer = new MutationObserver(() => {
        if (!document.body.contains(root)) {
          clearInterval(timer);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },

    sizingChartHurryBox: uniqueId => {
      const container = document.querySelector('#card-container-' + uniqueId);
      if (!container) return;

      const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');

      const isMobile = window.innerWidth <= 768;

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          if (!answer) return;

          const isOpen = answer.classList.contains('open');

          container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('.accordion-icon').forEach(icon => {
            icon.classList.remove('open');
          });

          if (!isOpen) {
            answer.classList.add('open');

            if (isMobile) {
              answer.style.maxHeight = 'none';
            } else {
              answer.style.maxHeight = answer.scrollHeight + 'px';
            }

            const icon = question.querySelector('.accordion-icon');
            if (icon) {
              icon.classList.add('open');
            }
          }
        });
      });
    },

    saintbrandShipping: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const root = container.querySelector('[data-attribute="saintbrand-shipping"]');
      if (!root) return;

      const deliveryDaysEl = root.querySelector('[data-attribute="saintbrand-shipping-delivery-days"]');
      const shipDateEl = root.querySelector('[data-attribute="saintbrand-shipping-ship-date"]');

      function formatShipDate(date) {
        return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      }

      function updateShipDate() {
        let days = 3;
        if (deliveryDaysEl) {
          const attr = parseInt(deliveryDaysEl.getAttribute('data-delivery-days'), 10);
          if (!Number.isNaN(attr)) days = attr;
        }
        const shipDate = new Date();
        shipDate.setDate(shipDate.getDate() + days);
        if (shipDateEl) {
          shipDateEl.textContent = formatShipDate(shipDate);
        }
      }

      updateShipDate();
    },

    orderInfo: uniqueId => {
      // Format date (DD MMM)
      function formatDate(date) {
        const options = { day: '2-digit', month: 'short' };
        return date.toLocaleDateString('en-US', options);
      }

      // Initialize order dates
      function initializeOrderDates(uniqueId) {
        const sectionRoot = document.querySelector('#order-info-section-' + uniqueId);
        if (!sectionRoot) return;

        const now = new Date();
        const orderDate = now;

        const orderDateEl = sectionRoot.querySelector('.order-date');
        const shippingDateEl = sectionRoot.querySelector('.shipping-date');
        const deliveredDateEl = sectionRoot.querySelector('.delivered-date');

        let shippingDays = 10;
        let deliveryDays = 5;

        const timelineEl = sectionRoot.querySelector('.timeline');

        if (timelineEl) {
          const shippingAttr = parseInt(timelineEl.getAttribute('data-timeline-shipping-days'), 10);
          const deliveryAttr = parseInt(timelineEl.getAttribute('data-timeline-delivery-days'), 10);
          if (!Number.isNaN(shippingAttr)) shippingDays = shippingAttr;
          if (!Number.isNaN(deliveryAttr)) deliveryDays = deliveryAttr;
        }

        const shippingStartDate = new Date(now);
        shippingStartDate.setDate(shippingStartDate.getDate() + 1);

        const shippingEndDate = new Date(now);
        shippingEndDate.setDate(shippingEndDate.getDate() + shippingDays);

        const deliveredStartDate = new Date(shippingEndDate);
        const deliveredEndDate = new Date(deliveredStartDate);
        deliveredEndDate.setDate(deliveredEndDate.getDate() + deliveryDays);

        if (orderDateEl) {
          orderDateEl.textContent = formatDate(orderDate);
        }
        if (shippingDateEl) {
          shippingDateEl.textContent = formatDate(shippingStartDate) + ' - ' + formatDate(shippingEndDate);
        }
        if (deliveredDateEl) {
          deliveredDateEl.textContent = formatDate(deliveredStartDate) + ' - ' + formatDate(deliveredEndDate);
        }
      }

      // Accordion functionality
      function initializeAccordion(uniqueId) {
        const sectionRoot = document.querySelector('#order-info-section-' + uniqueId);
        if (!sectionRoot) return;

        const items = sectionRoot.querySelectorAll('.accordion-item');

        items.forEach(item => {
          const header = item.querySelector('.accordion-header');
          const content = item.querySelector('.accordion-content');
          const chevron = item.querySelector('.chevron');

          if (header && content && chevron) {
            header.addEventListener('click', () => {
              const isOpen = content.classList.contains('open');

              // Close all accordion items in this section only
              sectionRoot.querySelectorAll('.accordion-content').forEach(c => c.classList.remove('open'));
              sectionRoot.querySelectorAll('.chevron').forEach(ch => ch.classList.remove('rotate'));

              // Open clicked item if it wasn't open
              if (!isOpen) {
                content.classList.add('open');
                chevron.classList.add('rotate');
              }
            });
          }
        });
      }

      initializeOrderDates(uniqueId);
      initializeAccordion(uniqueId);

      if (window.Swiper && typeof window.Swiper === 'function') {
        new window.Swiper('#order-info-section-' + uniqueId + ' .swiper', {
          slidesPerView: 1,
          spaceBetween: 16,
          uniqueNavElements: true,
          pagination: {
            el: '#order-info-section-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpointsBase: 'container',
          breakpoints: {
            0: { slidesPerView: 1 },
            640: { slidesPerView: 1 },
            1024: { slidesPerView: 1 },
            1200: { slidesPerView: 1 },
          },
        });
      }
    },
    subscribeEmailSection: uniqueId => {
      const cardContainer = document.querySelector(`[data-type="section-subcribe-email"] [data-id="${uniqueId}"]`);
      if (!cardContainer) return;

      const section = cardContainer.closest('[data-type="section-subcribe-email"]');
      if (!section || section.getAttribute('data-subscribe-email-bound') === 'true') return;

      const input = section.querySelector('[data-attribute="input-email"]');
      const button = section.querySelector('[data-attribute="button-submit"]');
      const form = section.querySelector('[data-attribute="form-subcribe"]');
      if (!input || !button) return;

      section.setAttribute('data-subscribe-email-bound', 'true');

      const storageKey = 'newsletter_subscribed';

      const handleSubmit = () => {
        const email = (input.value || '').trim();
        if (!email) return;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;

        try {
          let stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
          if (!Array.isArray(stored)) stored = [];

          const exists = stored.some(item => item && item.email === email);
          if (!exists) {
            stored.push({
              email,
              subscribedAt: new Date().toISOString(),
            });
            localStorage.setItem(storageKey, JSON.stringify(stored));
          }

          input.value = '';
        } catch (error) {
          console.error('Failed to save subscribe email', error);
        }
      };

      button.addEventListener('click', handleSubmit);
      if (form) {
        form.addEventListener('submit', event => {
          event.preventDefault();
          handleSubmit();
        });
      }
    },

    tabsSection: uniqueId => {
      const wrapperContainer = document.getElementById('wrapper-container-' + uniqueId);
      if (!wrapperContainer) return;
      const tabHeaderItems = wrapperContainer.querySelectorAll('[data-attribute="tab-header-item"]');
      const tabContentItems = wrapperContainer.querySelectorAll('[data-attribute="tab-content-item"]');
      const listTabContent = wrapperContainer.querySelector('[data-attribute="list-tab-content"]');
      if (!tabHeaderItems?.length || !tabContentItems?.length || !wrapperContainer || !listTabContent) return;

      tabHeaderItems.forEach(item => {
        item.addEventListener('click', () => {
          tabHeaderItems.forEach(item => {
            item.classList.remove('active');
          });
          tabContentItems.forEach(item => {
            item.classList.remove('active');
          });
          const tabId = item.getAttribute('data-tab');
          item.classList.add('active');
          const tabContentItem = listTabContent.querySelector('[data-tab="' + tabId + '"]');
          if (tabContentItem) {
            tabContentItem.classList.add('active');
          }
        });
      });
    },

    cardVitalTab: uniqueId => {
      const root = document.getElementById('card-container-' + uniqueId);
      if (!root) return;
      const tabHeaderItems = root.querySelectorAll('[data-attribute="tab-header-item"]');
      const listTabContent = root.querySelector('[data-attribute="list-tab-content"]');
      if (!tabHeaderItems?.length || !listTabContent) return;

      tabHeaderItems.forEach(item => {
        item.addEventListener('click', () => {
          tabHeaderItems.forEach(h => h.classList.remove('active'));
          root.querySelectorAll('[data-attribute="tab-content-item"]').forEach(c => c.classList.remove('active'));
          const tabId = item.getAttribute('data-tab');
          item.classList.add('active');
          const tabContentItem = listTabContent.querySelector('[data-tab="' + tabId + '"]');
          if (tabContentItem) {
            tabContentItem.classList.add('active');
          }
        });
      });
    },

    cardCedrowWithTab: uniqueId => {
      const root = document.getElementById('card-container-' + uniqueId);
      if (!root) return;
      const tabHeaderItems = root.querySelectorAll('[data-attribute="tab-header-item"]');
      const listTabContent = root.querySelector('[data-attribute="list-tab-content"]');
      if (!tabHeaderItems?.length || !listTabContent) return;

      tabHeaderItems.forEach(item => {
        item.addEventListener('click', () => {
          tabHeaderItems.forEach(h => h.classList.remove('active'));
          root.querySelectorAll('[data-attribute="tab-content-item"]').forEach(c => c.classList.remove('active'));
          const tabId = item.getAttribute('data-tab');
          item.classList.add('active');
          const tabContentItem = listTabContent.querySelector('[data-tab="' + tabId + '"]');
          if (tabContentItem) {
            tabContentItem.classList.add('active');
          }
        });
      });
    },

    cardCedrowBenefitsPolicy: uniqueId => {
      const root = document.getElementById('card-container-' + uniqueId);
      if (!root) return;
      const heading = root.querySelector('[data-attribute="heading-benefit"]');
      const toggleBlock = root.querySelector('[data-attribute="toggle-block"]');
      if (!heading || !toggleBlock) return;

      heading.addEventListener('click', () => {
        const isCollapsed = toggleBlock.classList.toggle('collapsed');
        heading.classList.toggle('collapsed', isCollapsed);
        if (isCollapsed) {
          toggleBlock.style.maxHeight = toggleBlock.scrollHeight + 'px';
        } else {
          toggleBlock.style.maxHeight = null;
        }
      });
    },

    cardMediaSlider: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const videos = container.querySelectorAll('.wrap-item video');

      videos.forEach(video => {
        const wrap = video.closest('.wrap-item');
        const volumeWrap = wrap.querySelector('.volume');
        const volumeIcon = volumeWrap.querySelector('.volume-icon');
        const muteIcon = volumeWrap.querySelector('.mute-icon');

        video.muted = true;

        video.play().catch(() => {
          console.warn('Autoplay was prevented, video will play when user interacts');
        });

        volumeWrap.addEventListener('click', () => {
          if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'flex';
            muteIcon.style.display = 'none';
          } else {
            video.muted = true;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'flex';
          }
        });
      });

      if (window.Swiper && typeof window.Swiper === 'function') {
        const paginationEl = '#card-container-' + uniqueId + ' .swiper-pagination';

        // Get breakpoints from section element or use defaults
        const sectionEl = container.closest('section[data-type="section-card-media-slider"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          // Handle new format (mobile, tablet, desktop)
          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }

          // Handle migration from old format (breakpoint1/2/3)
          if (!mobileSlidesAttr) {
            const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
            if (bp1Slides) {
              mobileSlides = parseInt(bp1Slides, 10) || 1;
            }
          }
          if (!tabletSlidesAttr) {
            const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
            if (bp2Slides) {
              tabletSlides = parseInt(bp2Slides, 10) || 2;
            }
          }
          if (!desktopSlidesAttr) {
            const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');
            if (bp3Slides) {
              desktopSlides = parseInt(bp3Slides, 10) || 3;
            }
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper(`.swiper-video-${uniqueId}`, {
          slidesPerView: mobileSlides,
          spaceBetween: 15,
          loop: true,
          navigation: {
            nextEl: `.next-${uniqueId}`,
            prevEl: `.prev-${uniqueId}`,
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    cardMediaSlider02: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const videos = container.querySelectorAll('.wrap-item video');

      videos.forEach(video => {
        const wrap = video.closest('.wrap-item');
        const volumeWrap = wrap.querySelector('.volume');
        const volumeIcon = volumeWrap.querySelector('.volume-icon');
        const muteIcon = volumeWrap.querySelector('.mute-icon');

        video.muted = true;

        video.play().catch(() => {
          console.warn('Autoplay was prevented, video will play when user interacts');
        });

        volumeWrap.addEventListener('click', () => {
          if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'flex';
            muteIcon.style.display = 'none';
          } else {
            video.muted = true;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'flex';
          }
        });
      });

      if (window.Swiper && typeof window.Swiper === 'function') {
        const paginationEl = '#card-container-' + uniqueId + ' .swiper-pagination';

        // Get breakpoints from section element or use defaults
        const sectionEl = container.closest('section[data-type="section-card-media-slider-02"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 2;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          // Handle new format (mobile, tablet, desktop)
          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 2;
          }

          // Handle migration from old format (breakpoint1/2/3)
          if (!mobileSlidesAttr) {
            const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
            if (bp1Slides) {
              mobileSlides = parseInt(bp1Slides, 10) || 1;
            }
          }
          if (!tabletSlidesAttr) {
            const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
            if (bp2Slides) {
              tabletSlides = parseInt(bp2Slides, 10) || 2;
            }
          }
          if (!desktopSlidesAttr) {
            const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');
            if (bp3Slides) {
              desktopSlides = parseInt(bp3Slides, 10) || 2;
            }
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper(`.swiper-video-${uniqueId}`, {
          slidesPerView: mobileSlides,
          spaceBetween: 15,
          loop: true,
          navigation: {
            nextEl: `.next-${uniqueId}`,
            prevEl: `.prev-${uniqueId}`,
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    cardMediaSlider03: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const videos = container.querySelectorAll('.wrap-item video');

      videos.forEach(video => {
        const wrap = video.closest('.wrap-item');
        const volumeWrap = wrap.querySelector('.volume');
        const volumeIcon = volumeWrap.querySelector('.volume-icon');
        const muteIcon = volumeWrap.querySelector('.mute-icon');

        video.muted = true;

        video.play().catch(() => {
          console.warn('Autoplay was prevented, video will play when user interacts');
        });

        volumeWrap.addEventListener('click', () => {
          if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'flex';
            muteIcon.style.display = 'none';
          } else {
            video.muted = true;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'flex';
          }
        });
      });

      if (window.Swiper && typeof window.Swiper === 'function') {
        const paginationEl = '#card-container-' + uniqueId + ' .swiper-pagination';

        // Get breakpoints from section element or use defaults
        const sectionEl = container.closest('section[data-type="section-card-media-slider-03"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          // Handle new format (mobile, tablet, desktop)
          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }

          // Handle migration from old format (breakpoint1/2/3)
          if (!mobileSlidesAttr) {
            const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
            if (bp1Slides) {
              mobileSlides = parseInt(bp1Slides, 10) || 1;
            }
          }
          if (!tabletSlidesAttr) {
            const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
            if (bp2Slides) {
              tabletSlides = parseInt(bp2Slides, 10) || 2;
            }
          }
          if (!desktopSlidesAttr) {
            const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');
            if (bp3Slides) {
              desktopSlides = parseInt(bp3Slides, 10) || 3;
            }
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper(`.swiper-video-${uniqueId}`, {
          slidesPerView: mobileSlides,
          spaceBetween: 15,
          loop: true,
          navigation: {
            nextEl: `.next-${uniqueId}`,
            prevEl: `.prev-${uniqueId}`,
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    reviewGrid05Section: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const videos = container.querySelectorAll('.wrap-item video');

      videos.forEach(video => {
        const wrap = video.closest('.wrap-item');
        const volumeWrap = wrap.querySelector('.volume');
        const volumeIcon = volumeWrap.querySelector('.volume-icon');
        const muteIcon = volumeWrap.querySelector('.mute-icon');

        video.muted = true;

        video.play().catch(() => {
          console.warn('Autoplay was prevented, video will play when user interacts');
        });

        volumeWrap.addEventListener('click', () => {
          if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'flex';
            muteIcon.style.display = 'none';
          } else {
            video.muted = true;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'flex';
          }
        });
      });

      if (window.Swiper && typeof window.Swiper === 'function') {
        const paginationEl = '#card-container-' + uniqueId + ' .swiper-pagination';

        const sectionEl = container.closest('section[data-type="section-review-grid-05"]');
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 2;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 2;
          }

          if (!mobileSlidesAttr) {
            const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
            if (bp1Slides) {
              mobileSlides = parseInt(bp1Slides, 10) || 1;
            }
          }
          if (!tabletSlidesAttr) {
            const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
            if (bp2Slides) {
              tabletSlides = parseInt(bp2Slides, 10) || 2;
            }
          }
          if (!desktopSlidesAttr) {
            const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');
            if (bp3Slides) {
              desktopSlides = parseInt(bp3Slides, 10) || 2;
            }
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper(`.swiper-video-${uniqueId}`, {
          slidesPerView: mobileSlides,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: `.next-${uniqueId}`,
            prevEl: `.prev-${uniqueId}`,
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpointsBase: 'container',
          breakpoints: breakpoints,
        });
      }
    },

    cardStepInstructions: uniqueId => {
      const container = document.querySelector(`.card-step-instructions-${uniqueId}`);

      if (window.Swiper && typeof window.Swiper === 'function') {
        const sectionEl = container.closest('section[data-type="section-card-step-instructions"]');

        // Get breakpoints from section element or use defaults
        let mobileSlides = 1;
        let tabletSlides = 2;
        let desktopSlides = 3;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 2;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 3;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper(`.card-step-instructions-${uniqueId} .swiper`, {
          slidesPerView: mobileSlides,
          spaceBetween: 36,
          breakpointsBase: 'container',
          pagination: {
            el: '.card-step-instructions-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpoints: breakpoints,
        });
      }
    },

    itemsGridSection: uniqueId => {
      const container = document.querySelector(`#items-grid-section-${uniqueId}`);
      if (window.Swiper && typeof window.Swiper === 'function') {
        const sectionEl = container.closest('section[data-type="section-items-grid"]');

        // Get breakpoints from section element or use defaults
        let mobileSlides = 1;
        let tabletSlides = 3;
        let desktopSlides = 5;

        if (sectionEl) {
          const mobileSlidesAttr = sectionEl.getAttribute('data-breakpoint-mobile-slides');
          const tabletSlidesAttr = sectionEl.getAttribute('data-breakpoint-tablet-slides');
          const desktopSlidesAttr = sectionEl.getAttribute('data-breakpoint-desktop-slides');

          if (mobileSlidesAttr) {
            mobileSlides = parseInt(mobileSlidesAttr, 10) || 1;
          }
          if (tabletSlidesAttr) {
            tabletSlides = parseInt(tabletSlidesAttr, 10) || 3;
          }
          if (desktopSlidesAttr) {
            desktopSlides = parseInt(desktopSlidesAttr, 10) || 5;
          }
        }

        const breakpoints = {
          640: { slidesPerView: tabletSlides },
          1024: { slidesPerView: desktopSlides },
        };

        new window.Swiper(`#items-grid-section-${uniqueId} .swiper`, {
          slidesPerView: mobileSlides,
          spaceBetween: 16,
          breakpointsBase: 'container',
          pagination: {
            el: '#items-grid-section-' + uniqueId + ' .swiper-pagination',
            clickable: true,
          },
          breakpoints: breakpoints,
        });
      }
    },
    itemsSlideB1: uniqueId => {
      if (window.Swiper && typeof window.Swiper === 'function') {
        new window.Swiper('.mySwiper-' + uniqueId, {
          slidesPerView: 4,
          spaceBetween: 16,
          pagination: {
            el: '.swiper-pagination-' + uniqueId,
            clickable: true,
          },
          breakpointsBase: 'container',
          breakpoints: {
            0: {
              slidesPerView: 1.1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 4,
            },
          },
        });
      }
    },
    bannerMediaSection: uniqueId => {
      const container = document.querySelector(`.banner-media-wrapper-${uniqueId}`);
      if (!container) return;

      const playIcon = container.querySelector('.banner-media-play-icon');
      if (!playIcon) return;

      const rawVideoUrl = playIcon.getAttribute('data-video-url');
      if (!rawVideoUrl) return;

      const sectionRoot = container.closest('section[data-type]') || container.parentElement;
      const modal = sectionRoot?.querySelector('.banner-media-modal') || document.querySelector('.banner-media-modal');
      if (!modal) return;

      const modalBody = modal.querySelector('.banner-media-modal-body');
      const closeButton = modal.querySelector('[data-banner-media-close]');
      if (!modalBody) return;

      const closeModal = () => {
        modal.style.display = 'none';
        modal.classList.remove('is-audio');
        modalBody.innerHTML = '';
      };

      if (!modal.dataset.closeBound) {
        closeButton?.addEventListener('click', closeModal);
        modal.addEventListener('click', event => {
          if (event.target === modal) {
            closeModal();
          }
        });
        modal.dataset.closeBound = 'true';
      }

      playIcon.addEventListener('click', () => {
        if (isYoutubeUrl(rawVideoUrl)) {
          const videoUrl = normalizeYoutubeEmbedUrl(rawVideoUrl);
          if (!videoUrl) return;
          modal.classList.remove('is-audio');
          modalBody.innerHTML = `<iframe class="banner-media-iframe" src="${videoUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        } else {
          modal.classList.add('is-audio');
          modalBody.innerHTML = `<video class="banner-media-video" src="${rawVideoUrl}" controls autoplay playsinline></video>`;
        }
        modal.style.display = 'flex';
      });
    },
    cardMultiToolSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('.accordion-icon').forEach(icon => {
            icon.classList.remove('open');
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('.accordion-icon').classList.add('open');
          }
        });
      });
    },
    cardFaqRivoneed: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          if (!answer) return;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('.accordion-icon').forEach(icon => {
            icon.classList.remove('open');
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('.accordion-icon')?.classList.add('open');
          }
        });
      });
    },
    policyYuriVideosSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector(`.policy-yuri-videos-swiper-${uniqueId}`);
      if (!swiperEl) return;
      if (swiperEl.swiper) return;

      new window.Swiper(swiperEl, {
        slidesPerView: 3.5,
        spaceBetween: 5,
        breakpointsBase: 'container',
        breakpoints: {
          1024: { slidesPerView: 3.5, spaceBetween: 5 },
        },
        pagination: {
          el: `#card-container-${uniqueId} .swiper-pagination`,
          clickable: true,
        },
      });
    },
    policyYuriReivewSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.swiper');
      if (!swiperEl) return;
      if (swiperEl.swiper) return;

      new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        pagination: {
          el: `#card-container-${uniqueId} .swiper-pagination`,
          clickable: true,
        },
      });
    },
    cardMultiToolDoubleSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.body-swiper');
      if (!swiperEl) return;

      // Avoid creating multiple Swiper instances on re-render.
      if (swiperEl.swiper) return;

      new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: `#card-container-${uniqueId} .swiper-button-next`,
          prevEl: `#card-container-${uniqueId} .swiper-button-prev`,
        },
        breakpoints: {},
      });

      const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('.accordion-icon').forEach(icon => {
            icon.classList.remove('open');
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('.accordion-icon').classList.add('open');
          }
        });
      });
    },
    reviewTitanSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      if (window.Swiper && typeof window.Swiper === 'function') {
        const swiperEl = container.querySelector('.swiper');
        if (!swiperEl) return;

        const bodyReview = container.querySelector('[data-attribute="body-review"]');
        const slidesPerViewDesktop = parseInt(bodyReview?.getAttribute('data-col-per-view') || '4', 10) || 4;

        new window.Swiper(swiperEl, {
          slidesPerView: 2,
          spaceBetween: 10,
          navigation: {
            nextEl: `#card-container-${uniqueId} .swiper-button-next`,
            prevEl: `#card-container-${uniqueId} .swiper-button-prev`,
          },
          breakpointsBase: 'container',
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          pagination: {
            el: `#card-container-${uniqueId} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            1024: {
              spaceBetween: '30px',
              slidesPerView: slidesPerViewDesktop,
            },
          },
        });
      }
    },
    reviewVitalSection: uniqueId => {
      //elements
      const constainer = document.getElementById(`card-container-${uniqueId}`);
      const closePreviewElement = constainer.querySelector('[data-attribute="close-preview"]');
      const modalPreviewElement = constainer.querySelector('[data-attribute="modal-preview"]');
      const viewMoreReviewElement = constainer.querySelector('[data-attribute="view-more-review"]');
      const totalReviewsElement = constainer.querySelector('[data-attribute="total-reviews"]');

      //product review
      const imgProductReview = constainer.getAttribute('data-img-product-review');
      const titleProductReview = constainer.getAttribute('data-title-product-review');
      const nameProductReview = constainer.getAttribute('data-name-product-review');

      const dataPayload = constainer.getAttribute('data-payload');
      const dataSource = dataPayload ? JSON.parse(dataPayload) : [];
      totalReviewsElement.textContent = dataSource.length;

      //pageLimit
      let pageLimit = parseInt(constainer.getAttribute('data-page-limit'));

      //add event
      viewMoreReviewElement.addEventListener('click', () => {
        handleViewMoreReview(pageLimit);
      });

      //close modal
      if (closePreviewElement) {
        closePreviewElement.addEventListener('click', () => {
          handleCloseModalPreview();
        });
      }

      if (modalPreviewElement && !modalPreviewElement.dataset.bindOutsideClick) {
        modalPreviewElement.addEventListener('click', event => {
          if (event.target === modalPreviewElement) {
            handleCloseModalPreview();
          }
        });
        modalPreviewElement.dataset.bindOutsideClick = 'true';
      }

      //filter review
      const filterReview = [];

      const handleFilterReview = () => {
        const starsFilterElement = constainer.querySelectorAll('[data-attribute="stars-filter"]');
        if (starsFilterElement) {
          starsFilterElement.forEach(item => {
            item.addEventListener('click', () => {
              const stars = parseInt(item.getAttribute('data-value'));
              if (stars) {
                const index = filterReview.indexOf(stars);
                if (index === -1) {
                  filterReview.push(stars);
                  item.classList.add('active-stars-filter');
                } else {
                  filterReview.splice(index, 1);
                  item.classList.remove('active-stars-filter');
                }
                insertHtmlItemListReview(pageLimit, filterReview);
              }
            });
          });
        }
      };

      handleFilterReview();

      //admin reply
      const avatarAdmin = constainer.getAttribute('data-avatar-admin');
      const nameAdmin = constainer.getAttribute('data-name-admin');

      const renderAverageRating = async () => {
        const averageRatingElement = constainer.querySelector('[data-attribute="average-rating"]');
        const reviewStar5 = dataSource.filter(item => item.stars === 5).length;
        const reviewStar4 = dataSource.filter(item => item.stars === 4).length;
        const reviewStar3 = dataSource.filter(item => item.stars === 3).length;
        const reviewStar2 = dataSource.filter(item => item.stars === 2).length;
        const reviewStar1 = dataSource.filter(item => item.stars === 1).length;
        const totalReviews = dataSource.length;

        const averageRating =
          (reviewStar5 * 5 + reviewStar4 * 4 + reviewStar3 * 3 + reviewStar2 * 2 + reviewStar1 * 1) / totalReviews;
        averageRatingElement.textContent = averageRating.toFixed(1);

        const scoreStar5Element = constainer.querySelector('[data-attribute="score-star-5"]');
        scoreStar5Element.textContent = reviewStar5;
        const percentScore5StarElement = constainer.querySelector('[data-attribute="percent-score-5-star"]');
        const percentScore5Star = (reviewStar5 / totalReviews) * 100;
        percentScore5StarElement.style.width = percentScore5Star + '%';

        const scoreStar4Element = constainer.querySelector('[data-attribute="score-star-4"]');
        scoreStar4Element.textContent = reviewStar4;
        const percentScore4StarElement = constainer.querySelector('[data-attribute="percent-score-4-star"]');
        const percentScore4Star = (reviewStar4 / totalReviews) * 100;
        percentScore4StarElement.style.width = percentScore4Star + '%';

        const scoreStar3Element = constainer.querySelector('[data-attribute="score-star-3"]');
        scoreStar3Element.textContent = reviewStar3;
        const percentScore3StarElement = constainer.querySelector('[data-attribute="percent-score-3-star"]');
        const percentScore3Star = (reviewStar3 / totalReviews) * 100;
        percentScore3StarElement.style.width = percentScore3Star + '%';

        const scoreStar2Element = constainer.querySelector('[data-attribute="score-star-2"]');
        scoreStar2Element.textContent = reviewStar2;
        const percentScore2StarElement = constainer.querySelector('[data-attribute="percent-score-2-star"]');
        const percentScore2Star = (reviewStar2 / totalReviews) * 100;
        percentScore2StarElement.style.width = percentScore2Star + '%';

        const scoreStar1Element = constainer.querySelector('[data-attribute="score-star-1"]');
        scoreStar1Element.textContent = reviewStar1;
        const percentScore1StarElement = constainer.querySelector('[data-attribute="percent-score-1-star"]');
        const percentScore1Star = (reviewStar1 / totalReviews) * 100;
        percentScore1StarElement.style.width = percentScore1Star + '%';
      };

      // *----*----*----*----*
      const calcPercentScoreWouldecommendProduct = async () => {
        const reviewsNumber = dataSource.length;
        const totalRecommendResults = dataSource.reduce((acc, item) => acc + item.results, 0);
        const percentScoreResult = ((totalRecommendResults - reviewsNumber * 1) / (reviewsNumber * 4)) * 100;

        const totalRecommendEaseOfUse = dataSource.reduce((acc, item) => acc + item.easeOfUse, 0);
        const percentScoreEaseOfUse = ((totalRecommendEaseOfUse - reviewsNumber * 1) / (reviewsNumber * 4)) * 100;

        const totalRecommendTaste = dataSource.reduce((acc, item) => acc + item.taste, 0);
        const percentScoreTaste = ((totalRecommendTaste - reviewsNumber * 1) / (reviewsNumber * 4)) * 100;

        const percentScoreResultElement = constainer.querySelector('[data-attribute="percent-score-result"]');
        percentScoreResultElement.setAttribute('data-value', percentScoreResult);
        percentScoreResultElement.style.width = percentScoreResult + '%';

        const percentScoreEaseOfUseElement = constainer.querySelector('[data-attribute="percent-score-ease-of-use"]');
        percentScoreEaseOfUseElement.setAttribute('data-value', percentScoreEaseOfUse);
        percentScoreEaseOfUseElement.style.width = percentScoreEaseOfUse + '%';

        const percentScoreTasteElement = constainer.querySelector('[data-attribute="percent-score-taste"]');
        percentScoreTasteElement.setAttribute('data-value', percentScoreTaste);
        percentScoreTasteElement.style.width = percentScoreTaste + '%';

        const percentScoreSum = (percentScoreResult + percentScoreEaseOfUse + percentScoreTaste) / 3;
        const percentScoreRecommendProductElement = constainer.querySelector(
          '[data-attribute="percent-score-recommend-product"]',
        );
        percentScoreRecommendProductElement.setAttribute('data-value', percentScoreSum);
        percentScoreRecommendProductElement.textContent = percentScoreSum.toFixed(0) + '%';
      };

      calcPercentScoreWouldecommendProduct();

      const swiperContainerElement = constainer.querySelector('.swiper-slider-' + uniqueId);

      const mySwiper = new window.Swiper(swiperContainerElement, {
        slidesPerView: 5,
        spaceBetween: 16,
        breakpointsBase: 'container',
        breakpoints: {
          768: {
            slidesPerView: 10,
            spaceBetween: 16,
          },
        },
      });

      const initSliderZoomPreview = async () => {
        const swiperZoomPreviewElement = constainer.querySelector('.swiper-zoom-preview');
        const swiperThumbPreviewElement = constainer.querySelector('.swiper-thumb-preview');
        if (swiperZoomPreviewElement && swiperThumbPreviewElement) {
          const mySwiperThumbPreview = new window.Swiper(swiperThumbPreviewElement, {
            slidesPerView: 5,
            spaceBetween: 10,
          });
          new window.Swiper(swiperZoomPreviewElement, {
            slidesPerView: 1,
            spaceBetween: 16,
            thumbs: {
              swiper: mySwiperThumbPreview,
            },
          });
        }
      };

      const handleOpenModalPreview = async id => {
        const item = dataSource.find(item => item.id == id);
        if (item) {
          const modalPreviewElement = constainer.querySelector('[data-attribute="modal-preview"]');
          const avatarUserElement = modalPreviewElement.querySelector('[data-attribute="avatar-user"]');
          const userNameElement = modalPreviewElement.querySelector('[data-attribute="user-name"]');
          const percentRatingStarElement = modalPreviewElement.querySelector('[data-attribute="percent-rating-star"]');
          const titleReviewElement = modalPreviewElement.querySelector('[data-attribute="title-review"]');
          const contentReviewTextElement = modalPreviewElement.querySelector('[data-attribute="content-review-text"]');
          // const imgUserUploadElement = modalPreviewElement.querySelector('[data-attribute="img-user-upload"]')

          const listItemZoomPreviewElement = modalPreviewElement.querySelector(
            '[data-attribute="list-item-zoom-preview"]',
          );
          if (listItemZoomPreviewElement) {
            listItemZoomPreviewElement.innerHTML = item.media.img
              .map(
                image => `
              <div data-id="${item.id}" class="swiper-slide">
                <div class="image-thumb-preview">
                  <img src="${image.url}" alt="${item.name}">
                </div>
              </div>
            `,
              )
              .join('');
          }

          const listItemThumbPreviewElement = modalPreviewElement.querySelector(
            '[data-attribute="list-item-thumb-preview"]',
          );
          if (listItemThumbPreviewElement) {
            listItemThumbPreviewElement.innerHTML = item.media.img
              .map(
                image => `
              <div data-id="${image.id}" class="swiper-slide">
                <div class="image-thumb-preview">
                  <img src="${image.url}" alt="${item.name}">
                </div>
              </div>
            `,
              )
              .join('');
          }

          const imgProductElement = modalPreviewElement.querySelector('[data-attribute="img-product"]');
          const titleReviewedProductElement = modalPreviewElement.querySelector(
            '[data-attribute="title-reviewed-product"]',
          );
          const nameProductElement = modalPreviewElement.querySelector('[data-attribute="name-product"]');

          imgProductElement.src = imgProductReview;
          titleReviewedProductElement.textContent = titleProductReview;
          nameProductElement.textContent = nameProductReview;

          avatarUserElement.src = item.avatar;
          userNameElement.textContent = item.name;
          percentRatingStarElement.style.width = item.stars * 20 + '%';
          titleReviewElement.textContent = item.title;
          contentReviewTextElement.textContent = item.content;
          // imgUserUploadElement.src = item.media?.img?.[0]?.url || ''

          modalPreviewElement.classList.add('active-modal-preview');

          initSliderZoomPreview();
        }
      };

      const handleCloseModalPreview = async () => {
        const modalPreviewElement = constainer.querySelector('[data-attribute="modal-preview"]');
        modalPreviewElement.classList.remove('active-modal-preview');
      };

      //insert inner html item slider
      const innerHtmlItemSlider = async () => {
        const listItemSliderElement = constainer.querySelector('[data-attribute="list-item-slider"]');
        if (listItemSliderElement) {
          //   listItemSliderElement.innerHTML = dataSource
          //     .map(item =>
          //       item.media?.img?.[0]?.url
          //         ? `
          //   <div data-attribute="item-slider" data-id="${item.id}" class="swiper-slide">
          //     <div class="image-slider">
          //       <img src="${item.media.img[0].url}" alt="${item.name}">
          //     </div>
          //   </div>
          // `
          //         : '',
          //     )
          //       .join('')

          listItemSliderElement.innerHTML = dataSource
            .flatMap(itemReview =>
              itemReview.media.img.map(
                image => `
                  <div data-attribute="item-slider" data-id="${itemReview.id}" class="swiper-slide">
                    <div class="image-slider">
                      <img src="${image.url}" alt="${itemReview.name}">
                    </div>
                  </div>
                `,
              ),
            )
            .join('');

          const itemSliderElement = await constainer.querySelectorAll('[data-attribute="item-slider"]');
          if (itemSliderElement) {
            itemSliderElement.forEach(item => {
              item.addEventListener('click', () => {
                handleOpenModalPreview(item.getAttribute('data-id'));
              });
            });
          }
        }
        await mySwiper.init();
      };
      innerHtmlItemSlider();

      const insertHtmlItemListReview = async (pageLimit = 10, filterReview = []) => {
        const listItemReviewElement = constainer.querySelector('[data-attribute="list-item-review"]');

        const dataFilterReview = dataSource.filter(item => {
          if (filterReview.length > 0) {
            return filterReview.includes(item.stars);
          }
          return true;
        });

        if (listItemReviewElement) {
          if (!listItemReviewElement.dataset.bindPreviewImageClick) {
            listItemReviewElement.addEventListener('click', event => {
              const imageItemElement = event.target.closest('[data-attribute="item-review-image"]');
              if (!imageItemElement) return;
              handleOpenModalPreview(imageItemElement.getAttribute('data-id'));
            });
            listItemReviewElement.dataset.bindPreviewImageClick = 'true';
          }

          listItemReviewElement.innerHTML =
            dataFilterReview.length > 0
              ? dataFilterReview
                  .slice(0, pageLimit)
                  .map(
                    item => `
            <div data-attribute="item-review" data-id="${item.id}" class="wrap-item-review">
              <div class="left-item">
                <div class="block-user">
                  <div class="avatar-user">
                    <img data-attribute="avatar-user"
                      src="${item.avatar}"
                      alt="">
                  </div>
                  <div class="name-user">
                    <div data-attribute="user-name" class="name-user-text">${item.name}</div>
                    <div class="verified-user">
                      <span>Verified Buyer</span>
                      <span class="icon-check">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="reviewed-product">
                  <div class="img-product">
                    <img data-attribute="img-product"
                      src="${imgProductReview}"
                      alt="">
                  </div>
                  <div class=" text-reviewed-product">
                    <div data-attribute="title-reviewed-product" class="title-reviewed-product">${titleProductReview}</div>
                    <div data-attribute="name-product" class="name-product">${nameProductReview}</div>
                  </div>
                </div>
                <div class="recommend-text">
                  <div class="icon-like">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-thumbs-up-icon lucide-thumbs-up">
                      <path
                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                      <path d="M7 10v12" />
                    </svg>
                  </div>
                  <span>I recommend this product</span>
                </div>
              </div>
              <div class="right-item">
                <div class="content-item">
                  <!-- svg star -->
                  <div class="svg-average-rating">
                    <div class="mask-star">
                      <div data-attribute="percent-rating-star" data-value="${item.stars *
                        20}" style="width: ${item.stars * 20}%;"
                        class="average-rating-star">
                      </div>
                    </div>
                  </div>
                  <div class="text-review">
                    <div class="title-review">${item.title}</div>
                    <div class="content-review-text">${item.content}</div>
                  </div>
                  <div class="wrap-chart-slider">
                    <div class="rating-scale">
                      <div class="title-scale">Results</div>
                      <div class="wrap-slider-core">
                        <div class="slider-core"></div>
                        <div class="list-dot">
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                        </div>
                        <div data-attribute="score-result" data-value="${(item.results >= 1 ? item.results - 1 : 0) *
                          25}" style="width: ${(item.results >= 1 ? item.results - 1 : 0) * 25}%;"
                          class="progress-bar-rating"></div>
                      </div>
                      <div class="text-start-end-slider">
                        <div class="text-item">Poor</div>
                        <div class="text-item">Excellent</div>
                      </div>
                    </div>
                    <div class="rating-scale">
                      <div class="title-scale">Ease of Use</div>
                      <div class="wrap-slider-core">
                        <div class="slider-core"></div>
                        <div class="list-dot">
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                        </div>
                        <div data-attribute="score-ease-of-use" data-value="${(item.easeOfUse >= 1
                          ? item.easeOfUse - 1
                          : 0) * 25}" style="width: ${(item.easeOfUse >= 1 ? item.easeOfUse - 1 : 0) * 25}%;"
                          class="progress-bar-rating"></div>
                      </div>
                      <div class="text-start-end-slider">
                        <div class="text-item">Poor</div>
                        <div class="text-item">Excellent</div>
                      </div>
                    </div>
                    <div class="rating-scale">
                      <div class="title-scale">TasteRated</div>
                      <div class="wrap-slider-core">
                        <div class="slider-core"></div>
                        <div class="list-dot">
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                          <div class="dot-item"></div>
                        </div>
                        <div data-attribute="score-taste" data-value="${(item.taste >= 1 ? item.taste - 1 : 0) *
                          25}" style="width: ${(item.taste >= 1 ? item.taste - 1 : 0) * 25}%;"
                          class="progress-bar-rating"></div>
                      </div>
                      <div class="text-start-end-slider">
                        <div class="text-item">Poor</div>
                        <div class="text-item">Excellent</div>
                      </div>
                    </div>
                  </div>
                  <div class="reaction-review">
                    <span>Was this helpful?</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-thumbs-up-icon lucide-thumbs-up">
                        <path
                          d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                        <path d="M7 10v12" />
                      </svg>
                      <span>${item.like}</span>
                    </span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-thumbs-down-icon lucide-thumbs-down">
                        <path
                          d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                        <path d="M17 14V2" />
                      </svg>
                      <span>${item.dislike}</span>
                    </span>
                  </div>
                </div>
                <div class="image-user-upload">
                  ${
                    item.media?.img?.length > 0
                      ? `
                    ${item.media.img
                      .map(
                        img => `
                      <div data-attribute="item-review-image" data-id="${item.id}" class="item">
                        <img
                          src="${img.url}"
                          alt="">
                      </div>
                    `,
                      )
                      .join('')}
                  `
                      : ''
                  }
                </div>
                <div class="admin-reply">
                  ${
                    item.replies.length > 0
                      ? `
                    ${item.replies
                      .map(
                        reply => `
                      <div class="item-reply">
                        <div class="avatar-admin">
                          <img
                            src="${avatarAdmin}"
                            alt="">
                        </div>
                        <div class="right-admin">
                          <div class="name-admin">${nameAdmin}</div>
                          <div class="content-reply">
                            ${reply.content}
                          </div>
                        </div>
                      </div>
                  `,
                      )
                      .join('')}
                  `
                      : ''
                  }
                </div>
              </div>
            </div>
          `,
                  )
                  .join('')
              : `
            <div class="no-review">
              <div class="no-review-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database-icon lucide-database"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5V19A9 3 0 0 0 21 19V5"/><path d="M3 12A9 3 0 0 0 21 12"/></svg>
              </div>
              <div class="no-review-text">
                <span>No reviews found</span>
              </div>
            </div>
            `;
        }

        if (pageLimit < dataFilterReview.length) {
          if (viewMoreReviewElement) {
            viewMoreReviewElement.classList.add('active-view-more-review');
          }
        } else {
          if (viewMoreReviewElement) {
            viewMoreReviewElement.classList.remove('active-view-more-review');
          }
        }
      };

      insertHtmlItemListReview(pageLimit, filterReview);

      const handleViewMoreReview = async (limit = 10) => {
        pageLimit += limit;
        insertHtmlItemListReview(pageLimit, filterReview);
        if (pageLimit >= dataSource.length) {
          viewMoreReviewElement.classList.remove('active-view-more-review');
        }
      };

      renderAverageRating();
    },
    cardVitalSlider: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      const swiperEl = container.querySelector(`.swiper-vital-${uniqueId}`);
      if (!swiperEl || swiperEl.swiper) return;

      const listEl = container.querySelector('[data-attribute="list-item"]');
      const colPerView = parseInt(listEl?.getAttribute('data-col-per-view') || '4', 10) || 4;
      const spaceBetween = parseInt(listEl?.getAttribute('data-space-between') || '16', 10) || 16;

      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const nextEl = container.querySelector('.swiper-button-next');
      const prevEl = container.querySelector('.swiper-button-prev');

      new window.Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        ...(nextEl && prevEl
          ? {
              navigation: {
                nextEl,
                prevEl,
              },
            }
          : {}),
        breakpointsBase: 'container',
        breakpoints: {
          640: {
            slidesPerView: Math.min(2, colPerView),
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: colPerView,
            spaceBetween,
          },
        },
      });
    },
    cardVitalSlider02: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      const swiperEl = container.querySelector(`.swiper-vital-${uniqueId}`);
      if (!swiperEl || swiperEl.swiper) return;

      const listEl = container.querySelector('[data-attribute="list-item"]');
      const colPerView = parseInt(listEl?.getAttribute('data-col-per-view') || '3', 10) || 3;
      const spaceBetween = parseInt(listEl?.getAttribute('data-space-between') || '16', 10) || 16;

      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const nextEl = container.querySelector('.swiper-button-next');
      const prevEl = container.querySelector('.swiper-button-prev');

      new window.Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        ...(nextEl && prevEl
          ? {
              navigation: {
                nextEl,
                prevEl,
              },
            }
          : {}),
        breakpointsBase: 'container',
        breakpoints: {
          640: {
            slidesPerView: Math.min(2, colPerView),
            spaceBetween,
          },
          1024: {
            slidesPerView: Math.min(3, colPerView),
            spaceBetween,
          },
          1200: {
            slidesPerView: colPerView,
            spaceBetween,
          },
        },
      });
    },

    sowhatbuyFeaturesSlider: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.sowhatbuy-features-slider__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const listEl = swiperEl.querySelector('[data-attribute="sowhatbuy-features-slider__list"]');
      if (!listEl) return;

      const slideEls = listEl.querySelectorAll('[data-attribute="sowhatbuy-features-slider__slide"]');
      const originalSlideCount = slideEls.length;
      if (originalSlideCount < 2) return;

      const TARGET_SLIDE_COUNT = 24;
      const INTERMEDIATE_SLIDE_COUNT = 8;

      const cloneSlide = slide => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-attribute');
        clone.setAttribute('data-clone-slide', 'true');
        return clone;
      };

      const fillSlidesToCount = (sources, targetCount) => {
        let count = listEl.querySelectorAll('.swiper-slide').length;
        let i = 0;
        while (count < targetCount) {
          listEl.appendChild(cloneSlide(sources[i % sources.length]));
          i += 1;
          count += 1;
        }
      };

      // Clone slide items only — tabs stay at original count
      const originals = Array.from(slideEls);
      fillSlidesToCount(originals, INTERMEDIATE_SLIDE_COUNT);
      const eightSlides = Array.from(listEl.querySelectorAll('.swiper-slide')).slice(0, INTERMEDIATE_SLIDE_COUNT);
      fillSlidesToCount(eightSlides, TARGET_SLIDE_COUNT);

      const tabEls = container.querySelectorAll('[data-attribute="sowhatbuy-features-slider__tab"]');

      const setActiveTab = index => {
        const tabIndex = ((index % originalSlideCount) + originalSlideCount) % originalSlideCount;
        tabEls.forEach((tab, i) => {
          const isActive = i === tabIndex;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('data-active', isActive ? 'true' : 'false');
        });
      };

      // (depth 2 -> 20/160/24, depth 3 -> 40/320/32)
      const FAN_STEP_X = 20;
      const FAN_BASE_Y = 160;
      const FAN_STEP_Y = 140;
      const FAN_BASE_ROTATE = 24;
      const FAN_STEP_ROTATE = 8;
      const FAN_MAX_ROTATE = 90;

      // direction: -1 for cards on the left (prev side), +1 for the right (next side)
      const applyFanTransform = (slide, depth, direction) => {
        // depth 0 (active) and depth 1 (prev/next) are styled via CSS !important
        if (depth <= 1) {
          slide.style.transform = '';
          return;
        }
        const x = -direction * FAN_STEP_X * (depth - 1);
        const y = FAN_BASE_Y + FAN_STEP_Y * (depth - 2);
        let rotate = FAN_BASE_ROTATE + FAN_STEP_ROTATE * (depth - 2);
        if (rotate > FAN_MAX_ROTATE) rotate = FAN_MAX_ROTATE;
        slide.style.transform = `translate(${x}px, ${y}px) rotate(${direction * rotate}deg) scale(1.05)`;
      };

      const layoutFanSlides = () => {
        const activeSlide = listEl.querySelector('.swiper-slide-active');
        if (!activeSlide) return;

        activeSlide.style.transform = '';

        let node = activeSlide.previousElementSibling;
        let depth = 1;
        while (node) {
          applyFanTransform(node, depth, -1);
          node = node.previousElementSibling;
          depth += 1;
        }

        node = activeSlide.nextElementSibling;
        depth = 1;
        while (node) {
          applyFanTransform(node, depth, 1);
          node = node.nextElementSibling;
          depth += 1;
        }
      };

      const scheduleFanLayout = () => {
        window.requestAnimationFrame(layoutFanSlides);
      };

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        speed: 500,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        initialSlide: TARGET_SLIDE_COUNT / 2,
        loopedSlides: originalSlideCount,
        loopAdditionalSlides: originalSlideCount,
        watchSlidesProgress: true,
        breakpointsBase: 'container',
        on: {
          init(swiperInstance) {
            setActiveTab(swiperInstance.realIndex);
            scheduleFanLayout();
          },
          slideChange(swiperInstance) {
            setActiveTab(swiperInstance.realIndex);
            scheduleFanLayout();
          },
          slideChangeTransitionEnd() {
            scheduleFanLayout();
          },
          loopFix() {
            scheduleFanLayout();
          },
        },
      });

      tabEls.forEach(tab => {
        tab.addEventListener('click', event => {
          event.preventDefault();
          const index = parseInt(tab.getAttribute('data-index'), 10);
          if (Number.isNaN(index)) return;
          if (typeof swiper.slideToLoop === 'function') {
            swiper.slideToLoop(index);
          } else {
            swiper.slideTo(index + TARGET_SLIDE_COUNT / 2);
          }
        });
      });

      layoutFanSlides();
    },

    reviewGrid04Section: uniqueId => {
      const container = document.querySelector(`#review-grid-wrapper-${uniqueId}`);
      if (!container) return;

      let currentTag = 'all';
      const pageSize = parseInt(container.getAttribute('data-page-size'), 10) || 4;
      let displayedCount = pageSize;

      const allItems = Array.from(container.querySelectorAll('[data-attribute="review-grid-item"]'));
      const loadMoreButton = container.querySelector('[data-attribute="load-more-button"]');
      const reviewGridItemEmpty = container.querySelector('[data-attribute="review-grid-item-empty"]');

      const getMatchingItems = () =>
        allItems.filter(item => (currentTag === 'all' ? true : item.getAttribute('data-tag') === currentTag));

      const getToggleTexts = () => {
        return {
          more: container.getAttribute('data-read-more-text') || 'read more',
          less: container.getAttribute('data-show-less-text') || 'show less',
        };
      };

      const setExpanded = (item, expanded) => {
        const content = item.querySelector('[data-attribute="review-content"]');
        if (!content) return;

        content.classList.toggle('is-expanded', expanded);

        const readMoreBtn = item.querySelector('[data-attribute="read-more-button"]');
        if (readMoreBtn) {
          const { more, less } = getToggleTexts();
          readMoreBtn.textContent = expanded ? less : more;
        }
      };

      const updateReadMoreVisibility = item => {
        const content = item.querySelector('[data-attribute="review-content"]');
        if (!content) return;

        const readMoreBtn = item.querySelector('[data-attribute="read-more-button"]');

        if (content.classList.contains('is-expanded')) {
          if (readMoreBtn) {
            const { less } = getToggleTexts();
            readMoreBtn.textContent = less;
            readMoreBtn.style.display = '';
          }
          return;
        }

        // const hasOverflow = content.scrollHeight > content.clientHeight + 1
        if (readMoreBtn) {
          const { more } = getToggleTexts();
          readMoreBtn.textContent = more;
          // readMoreBtn.style.display = hasOverflow ? '' : 'none'
        }
      };

      const updateDisplay = () => {
        const matchingItems = getMatchingItems();
        let visibleIndex = 0;

        allItems.forEach(item => {
          const matchesTag = currentTag === 'all' ? true : item.getAttribute('data-tag') === currentTag;

          if (matchesTag && visibleIndex < displayedCount) {
            item.style.display = 'flex';
            visibleIndex++;
            updateReadMoreVisibility(item);
          } else {
            item.style.display = 'none';
            setExpanded(item, false);
          }
        });

        if (reviewGridItemEmpty) {
          reviewGridItemEmpty.style.display = matchingItems.length === 0 ? 'flex' : 'none';
        }

        if (loadMoreButton) {
          loadMoreButton.style.display = displayedCount < matchingItems.length ? 'block' : 'none';
        }
      };

      updateDisplay();

      container.addEventListener('click', e => {
        const tagEl = e.target.closest('[data-attribute="review-tag-item"]');
        if (tagEl && container.contains(tagEl)) {
          const active = container.querySelector('[data-attribute="review-tag-item"].active');
          if (active) active.classList.remove('active');

          tagEl.classList.add('active');
          currentTag = tagEl.getAttribute('data-tag') || 'all';

          displayedCount = pageSize;
          updateDisplay();
          return;
        }

        const loadMoreEl = e.target.closest('[data-attribute="load-more-button"]');
        if (loadMoreEl && container.contains(loadMoreEl)) {
          displayedCount += pageSize;
          updateDisplay();
          return;
        }

        const readMoreEl = e.target.closest('[data-attribute="read-more-button"]');
        if (readMoreEl && container.contains(readMoreEl)) {
          const item = readMoreEl.closest('[data-attribute="review-grid-item"]');
          if (!item) return;
          const content = item.querySelector('[data-attribute="review-content"]');
          const nextExpanded = content ? !content.classList.contains('is-expanded') : true;
          setExpanded(item, nextExpanded);
          updateReadMoreVisibility(item);
          return;
        }
      });
    },

    itemsGridMediaSection: uniqueId => {
      const container = document.querySelector(`#items-grid-media-wrapper-${uniqueId}`);
      if (!container) return;

      const youtubeVideos = container.querySelectorAll('[data-attribute="items-grid-media-item-video-inner"]');

      youtubeVideos.forEach(video => {
        const src = video.getAttribute('src');
        if (!src) return;

        if (isYoutubeUrl(src)) {
          video.setAttribute('src', normalizeYoutubeEmbedUrl(src));
        }
      });

      const volume = container.querySelectorAll('.volume');
      if (volume && Array.from(volume).length > 0) {
        volume.forEach(item => {
          item.addEventListener('click', () => {
            const video = item.closest('.items-grid-media-item-video').querySelector('video');
            if (video.muted) {
              item.querySelector('.volume-icon').style.display = 'flex';
              item.querySelector('.mute-icon').style.display = 'none';
            } else {
              item.querySelector('.volume-icon').style.display = 'none';
              item.querySelector('.mute-icon').style.display = 'flex';
            }
            video.muted = !video.muted;
          });
        });
      }
    },

    gatorzCompareImageSection: uniqueId => {
      const containerInViewTPL = document.querySelector('#view-section-template');
      const container = containerInViewTPL
        ? containerInViewTPL.querySelector(`#card-container-${uniqueId}`)
        : document.querySelector(`#card-container-${uniqueId}`);

      if (!container) return;

      const overlayEl = container.querySelector('.img-comp-overlay');
      const containerX = container.querySelector('.img-comp-container');
      if (!overlayEl || !containerX) return;

      const overlayImg = overlayEl.querySelector('img');
      if (!overlayImg) return;

      const initialPercent = Number(containerX.getAttribute('data-initial-percent'));
      const startRatio = Number.isFinite(initialPercent) && initialPercent > 0 ? initialPercent / 100 : 0.5;

      compareImages(overlayEl, containerX, overlayImg, startRatio);

      function compareImages(img, containerX, overlayImg, startRatio) {
        let slider;
        let clicked = 0;
        let currentRatio = startRatio;

        slider = container.querySelector('.img-comp-slider');
        if (!slider) return;

        const getW = () => containerX.offsetWidth;

        const syncOverlayImageSize = () => {
          const w = getW();
          const h = containerX.offsetHeight;
          if (!w || !h) return;
          overlayImg.style.width = `${w}px`;
          overlayImg.style.height = `${h}px`;
        };

        const slide = xPos => {
          img.style.width = `${xPos}px`;
          slider.style.left = `${img.offsetWidth - slider.offsetWidth / 2}px`;
          const w = getW();
          if (w > 0) {
            currentRatio = xPos / w;
          }
        };

        const slideToRatio = ratio => {
          const w = getW();
          if (!w) return;
          slide(w * ratio);
        };

        const initSlider = () => {
          syncOverlayImageSize();
          slideToRatio(currentRatio);
        };

        initSlider();

        slider.addEventListener('mousedown', slideReady);
        window.addEventListener('mouseup', slideFinish);
        slider.addEventListener('touchstart', slideReady);
        window.addEventListener('touchend', slideFinish);

        function slideReady(e) {
          e.preventDefault();
          clicked = 1;
          window.addEventListener('mousemove', slideMove);
          window.addEventListener('touchmove', slideMove);
        }

        function slideFinish() {
          clicked = 0;
        }

        function slideMove(e) {
          if (!clicked) return;
          let pos = getCursorPos(e);
          const w = getW();
          pos = Math.max(0, Math.min(pos, w));
          slide(pos);
        }

        function getCursorPos(e) {
          const evt = e.changedTouches ? e.changedTouches[0] : e;
          const rect = img.getBoundingClientRect();
          return evt.pageX - rect.left - window.pageXOffset;
        }

        if (typeof ResizeObserver !== 'undefined') {
          const resizeObserver = new ResizeObserver(initSlider);
          resizeObserver.observe(containerX);
        } else {
          window.addEventListener('resize', initSlider);
        }
      }
    },

    gatorzYoutubeSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const iframe = container.querySelector('[data-attribute="gatorz-youtube__iframe"]');
      if (!iframe) return;

      const rawUrl = iframe.getAttribute('data-youtube-url') || '';
      const embedUrl = buildGatorzYoutubeEmbedUrl(rawUrl);
      if (embedUrl) {
        iframe.setAttribute('src', embedUrl);
      }

      if (iframe.dataset.loopBound) return;

      const youtubeOrigins = ['https://www.youtube.com', 'https://www.youtube-nocookie.com'];

      const sendCommand = (func, args = []) => {
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func, args }), '*');
      };

      const onMessage = event => {
        if (!youtubeOrigins.includes(event.origin)) return;
        if (event.source !== iframe.contentWindow) return;

        let data = event.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (_error) {
            return;
          }
        }

        const isEnded =
          (data?.event === 'onStateChange' && data?.info === 0) ||
          (data?.event === 'infoDelivery' && data?.info?.playerState === 0);

        if (isEnded) {
          sendCommand('seekTo', [0, true]);
          sendCommand('playVideo');
        }
      };

      iframe.addEventListener('load', () => {
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'listening' }), '*');
      });

      window.addEventListener('message', onMessage);
      iframe.dataset.loopBound = 'true';
    },

    gatorzSupportSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const wrapEl = container.querySelector('[data-attribute="gatorz-support-content"]');
      if (!wrapEl) return;

      initAccordionPrimary(wrapEl);
    },

    gatorzFrameSpecsSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;

      const wrapEl = container.querySelector('[data-attribute="gatorz-frame-specs-content"]');
      if (!wrapEl) return;

      initAccordionPrimary(wrapEl);
    },

    fastvaluedealCountdownSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) {
        return;
      }

      let script = document.currentScript;
      let root = script
        ? script.closest('section[data-type="section-fastvaluedeal-countdown"]')
        : container.closest('section[data-type="section-fastvaluedeal-countdown"]');

      if (!root) {
        return;
      }

      if (root.dataset.executed) {
        return;
      }
      root.dataset.executed = '1';

      const timerEl = root.querySelector('[data-attribute="fvd-countdown__timer-countdown-time"]');
      if (!timerEl) {
        return;
      }

      let totalSeconds = parseInt(timerEl.getAttribute('data-time'), 10);
      if (isNaN(totalSeconds)) {
        return;
      }
      totalSeconds *= 60;

      const tick = () => {
        const m = Math.floor(totalSeconds / 60);
        const s = totalSeconds % 60;
        timerEl.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        if (totalSeconds <= 0) {
          clearInterval(timer);
        } else {
          totalSeconds--;
        }
      };

      tick();
      const timer = setInterval(tick, 1000);

      const observer = new MutationObserver(() => {
        if (!document.body.contains(root)) {
          clearInterval(timer);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },

    fastvaluedealFaqSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) {
        return;
      }
      const faqQuestions = container.querySelectorAll('.item-question');

      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;
          const isOpen = answer.classList.contains('open');
          container.querySelectorAll('[data-attribute="item-answer"]').forEach(ans => {
            ans.classList.remove('open');
            ans.style.maxHeight = null;
          });
          container.querySelectorAll('[data-attribute="icon-plus"]').forEach(icon => {
            icon.style.display = 'block';
          });
          container.querySelectorAll('[data-attribute="icon-minus"]').forEach(icon => {
            icon.style.display = 'none';
          });

          if (!isOpen) {
            answer.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            question.querySelector('[data-attribute="icon-plus"]').style.display = 'none';
            question.querySelector('[data-attribute="icon-minus"]').style.display = 'block';
          }
        });
      });
    },

    tryherReviewGridSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !window.Swiper || typeof window.Swiper !== 'function') return;

      const sectionEl = container.closest('section[data-type="section-tryher-review-grid"]');
      const containerEl = container.querySelector('[data-attribute="tryher-review-grid"]');

      const getSlides = (name, fallback) => {
        const value = sectionEl && containerEl && containerEl.getAttribute(`data-breakpoint-${name}-slides`);
        return Number(value) || fallback;
      };

      new window.Swiper(`.tryher-review-grid-swiper-${uniqueId}`, {
        slidesPerView: getSlides('mobile', 1),
        spaceBetween: 24,
        navigation: {
          nextEl: `.next-${uniqueId}`,
          prevEl: `.prev-${uniqueId}`,
        },
        breakpointsBase: 'container',
        breakpoints: {
          1024: { slidesPerView: getSlides('tablet', 3) },
          1280: { slidesPerView: getSlides('desktop', 5) },
        },
      });
    },

    tryherGridPercentSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !window.Swiper || typeof window.Swiper !== 'function') return;

      const containerEl = container.querySelector('[data-attribute="tryher-grid-percent"]');
      const getSlides = (name, fallback) => {
        const value = containerEl && containerEl.getAttribute(`data-breakpoint-${name}-slides`);
        return Number(value) || fallback;
      };

      new window.Swiper(`.tryher-grid-percent-swiper-${uniqueId}`, {
        slidesPerView: getSlides('mobile', 1.5),
        spaceBetween: 18,
        breakpointsBase: 'container',
        breakpoints: {
          768: { slidesPerView: getSlides('tablet', 2) },
          1280: { slidesPerView: getSlides('desktop', 3) },
        },
      });
    },

    leonieandcoReviewGridSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.leonieandco-review-grid__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const slideEls = swiperEl.querySelectorAll('[data-attribute="leonieandco-review-grid__item"]');
      const tabEls = container.querySelectorAll('[data-attribute="leonieandco-review-grid__tab"]');
      if (!slideEls.length || !tabEls.length) return;

      const setActiveTab = index => {
        tabEls.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('data-active', isActive ? 'true' : 'false');
        });
      };

      const isMobile = window.innerWidth <= 768;

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: isMobile ? 1.08 : 1,
        spaceBetween: 12,
        speed: 450,
        watchOverflow: true,
        breakpointsBase: 'container',
        breakpoints: {
          600: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
        on: {
          init(swiperInstance) {
            setActiveTab(swiperInstance.activeIndex);
          },
          slideChange(swiperInstance) {
            setActiveTab(swiperInstance.activeIndex);
          },
        },
      });

      tabEls.forEach(tab => {
        tab.addEventListener('click', event => {
          event.preventDefault();
          const index = parseInt(tab.getAttribute('data-index'), 10);
          if (!Number.isNaN(index)) swiper.slideTo(index);
        });
      });
    },

    upairyTabsSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.upairy-tabs__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const slideEls = swiperEl.querySelectorAll("[data-attribute='upairy-tabs__item']");
      const tabEls = container.querySelectorAll("[data-attribute='upairy-tabs__tab']");
      if (!slideEls.length || !tabEls.length) return;

      const setActiveTab = index => {
        tabEls.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('data-active', isActive ? 'true' : 'false');
        });
      };

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 450,
        watchOverflow: true,
        breakpointsBase: 'container',
        breakpoints: {
          600: { slidesPerView: 1, spaceBetween: 16 },
        },
        on: {
          init(swiperInstance) {
            setActiveTab(swiperInstance.activeIndex);
          },
          slideChange(swiperInstance) {
            setActiveTab(swiperInstance.activeIndex);
          },
        },
      });

      tabEls.forEach(tab => {
        tab.addEventListener('click', event => {
          event.preventDefault();
          const index = parseInt(tab.getAttribute('data-index'), 10);
          if (!Number.isNaN(index)) swiper.slideTo(index);
        });
      });
    },

    sofyreTabsReviewSection: uniqueId => {
      const root = document.getElementById('card-container-' + uniqueId);
      if (!root) return;

      const tabItems = root.querySelectorAll('[data-attribute="tab-item"]');
      const tabPanels = root.querySelectorAll('[data-attribute="tab-panel"]');
      if (!tabItems.length || !tabPanels.length) return;

      tabItems.forEach(item => {
        item.addEventListener('click', () => {
          const tabId = item.getAttribute('data-tab');
          tabItems.forEach(t => t.classList.remove('active'));
          tabPanels.forEach(p => p.classList.remove('active'));
          item.classList.add('active');
          const panel = root.querySelector(`[data-attribute="tab-panel"][data-tab="${tabId}"]`);
          if (panel) panel.classList.add('active');
        });
      });

      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      tabPanels.forEach(panel => {
        const swiperEl = panel.querySelector('.tab-panel__content.swiper');
        if (!swiperEl || swiperEl.swiper) return;

        const nextEl = panel.querySelector('.swiper-button-next');
        const prevEl = panel.querySelector('.swiper-button-prev');

        new window.Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 16,
          observer: true,
          observeParents: true,
          ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
          breakpointsBase: 'container',
          breakpoints: {
            640: { slidesPerView: 2, spaceBetween: 16 },
            1024: { slidesPerView: 3, spaceBetween: 20 },
          },
        });
      });
    },

    konfortifyFbSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.wrap-slider-post-items .swiper');
      if (!swiperEl) return;
      if (swiperEl.swiper) return;

      const listPostEl = container.querySelector('[data-attribute="list-post"]');
      const desktopPerView = parseInt(listPostEl?.getAttribute('data-col-per-view') || '3', 10) || 3;

      const isMobile = window.innerWidth <= 768;

      new window.Swiper(swiperEl, {
        slidesPerView: isMobile ? 1.2 : 1,
        spaceBetween: 16,
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: 2 },
          1024: { slidesPerView: desktopPerView, spaceBetween: 20 },
        },
        loop: true,
        navigation: {
          nextEl: `#card-container-${uniqueId} .swiper-button-next`,
          prevEl: `#card-container-${uniqueId} .swiper-button-prev`,
        },
        pagination: {
          el: container.querySelector('.wrap-slider-post-items .swiper-pagination'),
          clickable: true,
        },
      });
    },
    konfortifyReviewGridSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !window.Swiper || typeof window.Swiper !== 'function') return;
      const swiperEl = container.querySelector(`.konfortify-review-grid-swiper-${uniqueId}`);
      if (!swiperEl || swiperEl.swiper) return;
      const isMobile = window.innerWidth <= 768;
      new window.Swiper(swiperEl, {
        slidesPerView: isMobile ? 1.2 : 1,
        spaceBetween: 16,
        pagination: {
          el: container.querySelector(`.konfortify-review-grid-pagination-${uniqueId}`),
          clickable: true,
        },
        navigation: {
          nextEl: container.querySelector(`.next-${uniqueId}`),
          prevEl: container.querySelector(`.previous-${uniqueId}`),
        },
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: 2 },
          960: { slidesPerView: 3 },
          1200: { slidesPerView: 5 },
        },
      });
    },
    furnitureshopGridSlider: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      if (!(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.furnitureshop-grid-slider__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const slideCount = swiperEl.querySelectorAll('[data-attribute=furnitureshop-grid-slider__slide]').length;
      if (!slideCount) return;

      new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slideCount > 1,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpointsBase: 'container',
        navigation: {
          prevEl: container.querySelector('.furnitureshop-grid-slider__navigation--prev'),
          nextEl: container.querySelector('.furnitureshop-grid-slider__navigation--next'),
        },
        pagination: {
          el: container.querySelector('.furnitureshop-grid-slider__pagination'),
          clickable: true,
        },
      });
    },
    furnitureshopGridSlider02: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !(window.Swiper && typeof window.Swiper === 'function')) return;

      const swiperEl = container.querySelector('.furnitureshop-grid-slider-02__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      const slideCount = swiperEl.querySelectorAll('[data-attribute="furnitureshop-grid-slider-02__slide"]').length;
      if (!slideCount) return;

      new window.Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 8,
        loop: slideCount > 4,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpointsBase: 'container',
        breakpoints: {
          769: { slidesPerView: 4, spaceBetween: 10 },
        },
        navigation: {
          prevEl: container.querySelector('.furnitureshop-grid-slider-02__navigation--prev'),
          nextEl: container.querySelector('.furnitureshop-grid-slider-02__navigation--next'),
        },
        pagination: {
          el: container.querySelector('.furnitureshop-grid-slider-02__pagination'),
          clickable: true,
        },
      });
    },
    furnitureshopCarousel: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);

      if (!container) return;

      const MOBILE_BREAKPOINT = 768;

      const getTrackAndImage = () => {
        const trackEl = container.querySelector('[data-attribute="furnitureshop-carousel__track"]');

        const imageEl = trackEl?.querySelector(
          '[data-attribute="furnitureshop-carousel__image"]:not([data-furnitureshop-carousel-clone])',
        );

        return {
          trackEl,
          imageEl,
        };
      };

      const cleanupCarousel = () => {
        const { trackEl } = getTrackAndImage();

        if (!trackEl) return;

        trackEl.querySelectorAll('[data-furnitureshop-carousel-clone]').forEach(cloneEl => cloneEl.remove());

        trackEl.removeAttribute('data-ready');
        trackEl.removeAttribute('data-images-per-set');
      };

      const setupMobileCarousel = () => {
        const containerWidth = container.getBoundingClientRect().width;

        if (!containerWidth) return;

        /**
         * Desktop:
         * remove all cloned images and restore original DOM.
         */
        if (containerWidth > MOBILE_BREAKPOINT) {
          cleanupCarousel();
          return;
        }

        const { trackEl, imageEl } = getTrackAndImage();

        if (!trackEl || !imageEl) return;

        const imageWidth = imageEl.getBoundingClientRect().width;

        if (!imageWidth) return;

        const imagesPerSet = Math.max(2, Math.ceil(containerWidth / imageWidth) + 1);

        const currentImagesPerSet = Number(trackEl.getAttribute('data-images-per-set'));

        /**
         * Already setup with correct number of images.
         */
        if (trackEl.getAttribute('data-ready') === 'true' && currentImagesPerSet === imagesPerSet) {
          return;
        }

        /**
         * Mobile width changed, so rebuild carousel.
         */
        cleanupCarousel();

        const firstSet = [imageEl];

        /**
         * Create first set.
         *
         * Original:
         * [A]
         *
         * Example result:
         * [A][A][A]
         */
        for (let index = 1; index < imagesPerSet; index += 1) {
          const clonedImageEl = imageEl.cloneNode(true);

          clonedImageEl.setAttribute('data-furnitureshop-carousel-clone', 'true');
          clonedImageEl.setAttribute('aria-hidden', 'true');

          trackEl.appendChild(clonedImageEl);
          firstSet.push(clonedImageEl);
        }

        /**
         * Duplicate first set for infinite animation.
         *
         * [A][A][A] | [A][A][A]
         */
        firstSet.forEach(itemEl => {
          const clonedImageEl = itemEl.cloneNode(true);

          clonedImageEl.setAttribute('data-furnitureshop-carousel-clone', 'true');
          clonedImageEl.setAttribute('aria-hidden', 'true');

          trackEl.appendChild(clonedImageEl);
        });

        trackEl.setAttribute('data-images-per-set', String(imagesPerSet));
        trackEl.setAttribute('data-ready', 'true');
      };

      setupMobileCarousel();

      if (typeof window.ResizeObserver !== 'function') return;

      const resizeObserver = new window.ResizeObserver(() => {
        setupMobileCarousel();
      });

      resizeObserver.observe(container);
    },
    furnitureshopFaq: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container) return;
      const items = Array.from(container.querySelectorAll('[data-attribute=furnitureshop-faq__item]'));

      const setOpen = (item, isOpen) => {
        const answer = item.querySelector('[data-attribute=item-answer]');
        const plusIcon = item.querySelector('[data-attribute=icon-plus]');
        const minusIcon = item.querySelector('[data-attribute=icon-minus]');
        item.classList.toggle('is-active', isOpen);
        item.setAttribute('data-active', isOpen ? 'true' : 'false');
        answer?.classList.toggle('open', isOpen);
        if (answer) answer.style.maxHeight = isOpen ? answer.scrollHeight + 'px' : null;
        if (plusIcon) plusIcon.style.display = isOpen ? 'none' : 'block';
        if (minusIcon) minusIcon.style.display = isOpen ? 'block' : 'none';
      };

      items.forEach(item => {
        setOpen(item, item.getAttribute('data-active') === 'true');
        const question = item.querySelector('[data-attribute=item-question]');
        question?.addEventListener('click', () => {
          const shouldOpen = !item.classList.contains('is-active');
          items.forEach(faqItem => setOpen(faqItem, false));
          if (shouldOpen) setOpen(item, true);
        });
      });
    },
    manchestoreCompareSliderSection: uniqueId => {
      const container = document.querySelector(`#card-container-${uniqueId}`);
      if (!container || !(window.Swiper && typeof window.Swiper === 'function')) return;
      const root = container.querySelector('[data-attribute=manchestore-compare-slider]');
      const swiperEl = root?.querySelector('.mcs__swiper');
      const handles = root?.querySelectorAll('.mcs__handle') || [];
      if (!root || !swiperEl || !handles.length || root.dataset.mcsInitialized === 'true') return;
      root.dataset.mcsInitialized = 'true';

      const disableCompareTransitions = () => {
        root.querySelectorAll('.mcs__handle, .mcs__before-layer').forEach(element => {
          element.style.setProperty('transition', 'none', 'important');
        });
      };
      disableCompareTransitions();

      const clamp = value => Math.min(100, Math.max(1, value));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let position = clamp(Number(root.getAttribute('data-compare-position')) || 50);
      let target = 90;
      let dragging = false;
      let animationFrame = null;
      let lastTime = 0;
      let swiper = null;

      const setPosition = value => {
        position = clamp(value);
        root.style.setProperty('--mcs-compare-position', `${position}%`);
        root.setAttribute('data-compare-position', position.toFixed(2));
      };
      const animate = time => {
        if (dragging || reducedMotion || !document.body.contains(root)) return;
        if (!lastTime) lastTime = time;
        const step = ((time - lastTime) / 2000) * 32;
        lastTime = time;
        const direction = target > position ? 1 : -1;
        const next = position + step * direction;
        if ((direction > 0 && next >= target) || (direction < 0 && next <= target)) {
          setPosition(target);
          target = target === 90 ? 10 : 90;
        } else {
          setPosition(next);
        }
        animationFrame = window.requestAnimationFrame(animate);
      };
      const resumeAnimation = () => {
        if (reducedMotion) return;
        lastTime = 0;
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(animate);
      };
      const finishDrag = event => {
        if (!dragging) return;
        event.preventDefault();
        event.stopPropagation();
        dragging = false;
        target = position >= 50 ? 10 : 90;
        if (swiper) swiper.allowTouchMove = true;
        if (swiper?.autoplay) swiper.autoplay.resume();
        resumeAnimation();
      };

      handles.forEach(handle => {
        handle.addEventListener('pointerdown', event => {
          event.preventDefault();
          event.stopPropagation();
          dragging = true;
          window.cancelAnimationFrame(animationFrame);
          if (swiper) swiper.allowTouchMove = false;
          if (swiper?.autoplay) swiper.autoplay.pause();
          handle.setPointerCapture?.(event.pointerId);
        });
        handle.addEventListener('pointermove', event => {
          if (!dragging) return;
          event.preventDefault();
          event.stopPropagation();
          const compareEl = handle.closest('[data-attribute=mcs__compare]');
          const rect = compareEl?.getBoundingClientRect();
          if (rect?.width) setPosition(((event.clientX - rect.left) / rect.width) * 100);
        });
        handle.addEventListener('pointerup', finishDrag);
        handle.addEventListener('pointercancel', finishDrag);
        handle.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          setPosition(position + (event.key === 'ArrowRight' ? 2 : -2));
          target = position >= 50 ? 10 : 90;
          resumeAnimation();
        });
      });

      setPosition(position);
      swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        speed: 550,
        loop: swiperEl.querySelectorAll('.swiper-slide').length > 1,
        watchOverflow: true,
        noSwiping: true,
        noSwipingSelector: '.mcs__handle',
        autoplay: { delay: 3500, disableOnInteraction: false },
        navigation: {
          nextEl: root.querySelector('.mcs__navigation--next'),
          prevEl: root.querySelector('.mcs__navigation--prev'),
        },
        pagination: { el: root.querySelector('.mcs__pagination'), clickable: true },
      });
      disableCompareTransitions();
      resumeAnimation();

      const observer = new MutationObserver(() => {
        if (document.body.contains(root)) return;
        window.cancelAnimationFrame(animationFrame);
        if (swiper && !swiper.destroyed) swiper.destroy(true, true);
        observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
    madamSizeCalculator: uniqueId => {
      const container = document.querySelector('#card-container-' + uniqueId);
      if (!container) return;
      const holder = container.querySelector('[data-attribute="calculator-holder"]');
      const bandEl = container.querySelector('[data-attribute="select-band"]');
      const cupEl = container.querySelector('[data-attribute="select-cup"]');
      const sizeEl = container.querySelector('[data-attribute="size-calculator"]');
      const textEl = container.querySelector('[data-attribute="text-resultes"]');
      if (!holder || !bandEl || !cupEl || !sizeEl || !textEl) return;

      let chart;
      try {
        chart = JSON.parse(holder.getAttribute('data-size-chart') || '{}');
      } catch (_e) {
        return;
      }
      const sizes = (chart.result && chart.result.sizes) || [];
      const emptyText = chart.emptyText || '';
      const fitsText = chart.fitsText || 'Size {size} fits:';
      const escapeHtml = str =>
        String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');

      const renderText = (size, combo) => {
        if (!size) {
          textEl.innerHTML = escapeHtml(emptyText);
          return;
        }
        const list = size.fits.map(fit => (fit === combo ? `<b>${escapeHtml(fit)}</b>` : escapeHtml(fit))).join(', ');
        textEl.innerHTML = `<b>${escapeHtml(fitsText.replace('{size}', size.display))}</b> ${list}`;
      };

      const handleBandCupChange = () => {
        const combo = bandEl.value && cupEl.value ? bandEl.value + cupEl.value : '';
        if (!combo) return;
        const size = sizes.find(s => s.fits.includes(combo));
        sizeEl.value = size ? size.display : '';
        renderText(size, combo);
      };

      bandEl.addEventListener('change', handleBandCupChange);
      cupEl.addEventListener('change', handleBandCupChange);
      sizeEl.addEventListener('change', () => {
        const size = sizes.find(s => s.display === sizeEl.value);
        let combo = bandEl.value && cupEl.value ? bandEl.value + cupEl.value : '';
        // keep band/cup only if they still belong to the picked size
        if (!size || !size.fits.includes(combo)) {
          bandEl.value = '';
          cupEl.value = '';
          combo = '';
        }
        renderText(size, combo);
      });
    },
  };

  const insertAnchorItem = (section, elMenu) => {
    if (!elMenu || !section) return;
    const nameAnchor = section.getAttribute('data-title');
    if (!nameAnchor) return;
    const enableAnchor = section.getAttribute('data-enable-anchor');
    if (enableAnchor === 'false' || !enableAnchor) return;

    const innerId = section.querySelector('[data-id]')?.getAttribute('data-id') || '';
    const stableKey =
      innerId ||
      nameAnchor
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');

    const existed = elMenu.querySelector(`[data-anchor-for="${stableKey}"]`);
    if (existed) return;

    const elMenuItem = elMenu.firstElementChild;
    const className = elMenuItem?.className || '';

    const newElMenuItem = document.createElement('div');
    newElMenuItem.className = className;
    newElMenuItem.textContent = nameAnchor;
    newElMenuItem.setAttribute('data-anchor-for', stableKey);
    elMenu.appendChild(newElMenuItem);

    newElMenuItem.addEventListener('click', () => {
      try {
        let foundSection = null;
        if (innerId) {
          const inner = document.querySelector(`[data-id="${innerId}"]`);
          foundSection = inner ? inner.closest('section[data-type]') : null;
        }
        if (!foundSection) {
          const candidates = Array.from(document.querySelectorAll('section[data-type]')).filter(
            s => s.getAttribute('data-title') === nameAnchor,
          );
          foundSection = candidates.length ? candidates[0] : null;
        }

        if (foundSection) {
          foundSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      } catch (_e) {
        console.error('Error in insertAnchorItem', _e);
      }
    });
  };
  const init = () => {
    const sectionHandlers = {
      [scriptSectionType.MARQUEE_TINO]: helperFunctions.marqueeTino,
      [scriptSectionType.MARKQUEUE_ROWS]: helperFunctions.markqueueRows,
      [scriptSectionType.FB_POST_03]: helperFunctions.fbPost03Section,
      [scriptSectionType.CARD_VIDEO_SLIDER]: helperFunctions.cardVideoSlider,
      [scriptSectionType.BANNER_SLIDER]: helperFunctions.bannerSlider,
      [scriptSectionType.CARD_ACCORDIONS]: helperFunctions.cardAccordions,
      [scriptSectionType.CARD_COMPARE_TWO_IMAGE]: helperFunctions.cardCompareTwoImage,
      [scriptSectionType.CARD_COMPARE_YURI]: helperFunctions.cardCompareYuri,
      [scriptSectionType.CARD_SLIDER_YURI]: helperFunctions.cardSliderYuri,
      [scriptSectionType.SLIDER_FASTVALUEDEAL_01]: helperFunctions.sliderFastvaluedeal01,
      [scriptSectionType.CARD_WITH_SLIDER_RIVONEED]: helperFunctions.cardWithSliderRivoneed,
      [scriptSectionType.CARD_SLIDER_RIVONEED]: helperFunctions.cardSliderRivoneed,
      [scriptSectionType.MARQUEE_RIVONEED]: helperFunctions.marqueeRivoneed,
      [scriptSectionType.CARD_FAQ_RIVONEED]: helperFunctions.cardFaqRivoneed,
      [scriptSectionType.REVIEW_SLIDER_YURI]: helperFunctions.reviewSliderYuriSection,
      [scriptSectionType.CARD_HAVE_VIEW_MORE]: helperFunctions.cardHaveViewMoreSection,
      [scriptSectionType.COLLAPSIBLE_PRODUCT_GRID]: helperFunctions.collapsibleProductGridSection,
      [scriptSectionType.FAQ_GRID]: helperFunctions.faqGridSection,
      [scriptSectionType.FAQ_GRID_02]: helperFunctions.faqGridSection,
      [scriptSectionType.FAQ_GRID_03]: helperFunctions.faqGridSection,
      [scriptSectionType.FAQ_GRID_04]: helperFunctions.faqGridSection,
      [scriptSectionType.FAQ_GRID_05]: helperFunctions.faqGridSection,
      [scriptSectionType.FAQ_GRID_06]: helperFunctions.faqGridSection,
      [scriptSectionType.FASTVALUEDEAL_FAQ]: helperFunctions.fastvaluedealFaqSection,
      [scriptSectionType.FAQ_CARD]: helperFunctions.faqGridSection,
      [scriptSectionType.ICON_WITH_TEXT_SLIDER]: helperFunctions.iconWithTextSliderSection,
      [scriptSectionType.MARQUEE_IMAGE]: helperFunctions.marqueeImageSection,
      [scriptSectionType.REVIEW_GRID_KIND_LOKAL]: helperFunctions.reviewGridKindLokalSection,
      [scriptSectionType.REVIEW_GRID]: helperFunctions.reviewGridSection,
      [scriptSectionType.REVIEW_GRID_02]: helperFunctions.reviewGrid02Section,
      [scriptSectionType.TEXT_CAROUSEL]: helperFunctions.textCarousel,
      [scriptSectionType.TINO_GRID]: helperFunctions.tinoGrid,
      [scriptSectionType.PRODUCT_REVIEWS]: helperFunctions.productReviews,
      [scriptSectionType.PRODUCT_REVIEWS_02]: helperFunctions.productReviews,
      [scriptSectionType.PRODUCT_REVIEWS_03]: helperFunctions.productReviews,
      [scriptSectionType.PRODUCT_REVIEWS_04]: helperFunctions.productReviews,
      [scriptSectionType.PRODUCT_REVIEWS_05]: helperFunctions.productReviews,
      [scriptSectionType.FASTVALUEDEAL_REVIEWS]: helperFunctions.productReviews,
      [scriptSectionType.PRODUCT_REVIEWS_06]: helperFunctions.productReviews,
      [scriptSectionType.CARD_MEDIA_SLIDER]: helperFunctions.cardMediaSlider,
      [scriptSectionType.CARD_MEDIA_SLIDER_02]: helperFunctions.cardMediaSlider02,
      [scriptSectionType.CARD_MEDIA_SLIDER_03]: helperFunctions.cardMediaSlider03,
      [scriptSectionType.CARD_STEP_INSTRUCTIONS]: helperFunctions.cardStepInstructions,
      [scriptSectionType.ITEMS_GRID_SECTION]: helperFunctions.itemsGridSection,
      [scriptSectionType.ITEMS_SLIDE_B1]: helperFunctions.itemsSlideB1,
      [scriptSectionType.BANNER_MEDIA]: helperFunctions.bannerMediaSection,
      [scriptSectionType.CARD_MULTI_TOOL]: helperFunctions.cardMultiToolSection,
      [scriptSectionType.CARD_MULTI_TOOL_DOUBLE]: helperFunctions.cardMultiToolDoubleSection,
      [scriptSectionType.REVIEW_TITAN]: helperFunctions.reviewTitanSection,
      [scriptSectionType.REVIEW_VITAL]: helperFunctions.reviewVitalSection,
      [scriptSectionType.FAQ_VITAL]: helperFunctions.cardMultiToolSection,
      [scriptSectionType.CARD_VITAL_SLIDER]: helperFunctions.cardVitalSlider,
      [scriptSectionType.CARD_VITAL_SLIDER_02]: helperFunctions.cardVitalSlider02,
      [scriptSectionType.CARD_VITAL_TAB]: helperFunctions.cardVitalTab,
      [scriptSectionType.CARD_CEDROW_WITH_TAB]: helperFunctions.cardCedrowWithTab,
      [scriptSectionType.CARD_CEDROW_BENEFITS_POLICY]: helperFunctions.cardCedrowBenefitsPolicy,
      [scriptSectionType.REVIEW_GRID_04]: helperFunctions.reviewGrid04Section,
      [scriptSectionType.REVIEW_GRID_05]: helperFunctions.reviewGrid05Section,
      [scriptSectionType.TRYHER_REVIEW_GRID]: helperFunctions.tryherReviewGridSection,
      [scriptSectionType.TRYHER_GRID_PERCENT]: helperFunctions.tryherGridPercentSection,
      [scriptSectionType.ITEMS_GRID_MEDIA]: helperFunctions.itemsGridMediaSection,
      [scriptSectionType.MARQUEE_YURI]: helperFunctions.marqueeYuriSection,
      [scriptSectionType.FASTVALUEDEAL_COUNTDOWN]: helperFunctions.fastvaluedealCountdownSection,
      [scriptSectionType.GATORZ_YOUTUBE]: helperFunctions.gatorzYoutubeSection,
      [scriptSectionType.GATORZ_COMPARE_IMAGE]: helperFunctions.gatorzCompareImageSection,
      [scriptSectionType.GATORZ_REVIEWS]: helperFunctions.productReviews,
      [scriptSectionType.SAINTBRAND_REVIEWS]: helperFunctions.productReviews,
      [scriptSectionType.LOSAPRILY_REVIEWS]: helperFunctions.productReviews,
      [scriptSectionType.GATORZ_SUPPORT]: helperFunctions.gatorzSupportSection,
      [scriptSectionType.GATORZ_FRAME_SPECS]: helperFunctions.gatorzFrameSpecsSection,
      // hurrybox
      [scriptSectionType.COUNT_DOWN_HURRY_BOX]: helperFunctions.countdownHurryBox,
      [scriptSectionType.SIZING_CHART_HURRY_BOX]: helperFunctions.sizingChartHurryBox,
      // order policy
      [scriptSectionType.POLICY_ACCORDION_BASIC]: helperFunctions.cardMultiToolSection,
      [scriptSectionType.POLICY_YURI_ACCORDION]: helperFunctions.cardMultiToolSection,
      [scriptSectionType.POLICY_YURI_VIDEOS]: helperFunctions.policyYuriVideosSection,
      [scriptSectionType.POLICY_YURI_REIVEW]: helperFunctions.policyYuriReivewSection,
      [scriptSectionType.ORDER_INFO]: helperFunctions.orderInfo,
      [scriptSectionType.SAINTBRAND_SHIPPING]: helperFunctions.saintbrandShipping,
      [scriptSectionType.TABS_SECTION]: helperFunctions.tabsSection,
      [scriptSectionType.SUBSCRIBE_EMAIL]: helperFunctions.subscribeEmailSection,
      [scriptSectionType.CARD_MEDIA_WITH_SLIDER_LOSAPRILY]: helperFunctions.cardMediaWithSliderLosaprily,
      [scriptSectionType.CARD_TAB_WITH_CONTENT_LOSAPRILY]: helperFunctions.cardTabWithContentLosaprily,
      [scriptSectionType.MARQUEE_SHOPZOVYA]: helperFunctions.marqueeShopzovya,
      [scriptSectionType.SOWHATBUY_FEATURES_SLIDER]: helperFunctions.sowhatbuyFeaturesSlider,
      [scriptSectionType.LEONIEANDCO_REVIEW_GRID]: helperFunctions.leonieandcoReviewGridSection,
      [scriptSectionType.UPAIRY_TABS]: helperFunctions.upairyTabsSection,
      [scriptSectionType.KONFORTIFY_FB]: helperFunctions.konfortifyFbSection,
      [scriptSectionType.KONFORTIFY_REVIEW_GRID]: helperFunctions.konfortifyReviewGridSection,
      [scriptSectionType.FURNITURESHOP_GRID_SLIDER]: helperFunctions.furnitureshopGridSlider,
      [scriptSectionType.FURNITURESHOP_GRID_SLIDER_02]: helperFunctions.furnitureshopGridSlider02,
      [scriptSectionType.FURNITURESHOP_CAROUSEL]: helperFunctions.furnitureshopCarousel,
      [scriptSectionType.FURNITURESHOP_FAQ]: helperFunctions.furnitureshopFaq,
      [scriptSectionType.MANCHESTORE_COMPARE_SLIDER]: helperFunctions.manchestoreCompareSliderSection,
      [scriptSectionType.SOFYRE_TABS_REVIEW]: helperFunctions.sofyreTabsReviewSection,
      [scriptSectionType.SOFYREGRID_TIMELINE]: helperFunctions.cardCedrowWithTab,
      [scriptSectionType.MADAM_SIZE_CALCULATOR]: helperFunctions.madamSizeCalculator,
    };

    const sections = document.querySelectorAll('[data-type]');

    const attributeMenu = options?.attributeMenu || '.menu-list-desktop';

    const elMenu = document.querySelectorAll(attributeMenu);

    sections.forEach(section => {
      if (!section) return;

      //handleSection
      const key = section.getAttribute('data-type');
      const executed = section.getAttribute('data-executed');
      const uniqueId = section.querySelector('[data-id]')?.getAttribute('data-id');
      if (executed || !key /*|| !uniqueId*/) return;

      const handler = sectionHandlers[key];
      if (typeof handler === 'function') {
        try {
          if (uniqueId) {
            handler(uniqueId);
            section.setAttribute('data-executed', 'true');
          }
        } catch (err) {
          console.error(`Error executing section [${key}] with id [${uniqueId}]`, err);
        }
      }
      if (elMenu && elMenu.length) {
        elMenu.forEach(el => {
          insertAnchorItem(section, el);
        });
      }
    });
  };

  try {
    if (options && options.force && typeof document !== 'undefined') {
      const executedSections = document.querySelectorAll('section[data-type][data-executed="true"]');
      executedSections.forEach(section => {
        try {
          section.removeAttribute('data-executed');
        } catch (_e) {
          console.error('Error removing attribute data-executed', _e);
        }
      });
    }
  } catch (_e) {
    console.error('Error in try block', _e);
  }

  loadSwiper(init);
}
